import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'

import { ExhibitorStory, useExhibitors } from '..'
import { locations } from './locations'
import { useExhibitorLocations } from './useExhibitorLocations'

import * as styles from './PlanDesktop.css'

export function PlanDesktop() {
  const exhibitors = useExhibitors()
  const exhibitorLocations = useExhibitorLocations(exhibitors)

  const [activeExhibitor, setActiveExhibitor] = useState<ExhibitorStory>()

  function onMouseEnter(e) {
    const booth = e.target.getAttribute('data-booth')

    const exhibitor = exhibitorLocations[booth]
    if (exhibitor) {
      setActiveExhibitor(exhibitor)
    } else {
      setActiveExhibitor(undefined)
    }
  }

  function onMouseLeave(e) {
    setActiveExhibitor(undefined)
  }

  function onClick(e) {
    if (activeExhibitor) {
      window.location.href = `/aussteller/${activeExhibitor.slug}`
    }
  }

  const activeLocation = activeExhibitor ? locations[activeExhibitor!.content.location_site!] : null

  return (
    <div css={styles.wrapper}>
      <AnimatePresence>
        {activeExhibitor && (
          <motion.div
            css={styles.active}
            initial={{ opacity: 0, y: '100%' }}
            animate={{ opacity: 1, y: '0' }}
            exit={{ opacity: 0, y: '100%' }}
            style={
              {
                '--color-path-base': activeLocation.colorBase,
                '--color-path-text': activeLocation.colorText,
              } as any
            }
          >
            <div css={styles.activeBox}>
              <div css={styles.activeMain}>
                <div css={styles.activeBooth}>{activeExhibitor!.content.location_booth}</div>
                <div css={styles.activeName}>{activeExhibitor.name}</div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <svg width={720} height={474} viewBox="0 0 720 474" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 1">
          <path
            id="BOOTH_1.10"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.10' in exhibitorLocations}
            data-booth="1.10"
            opacity="0.4"
            d="M279.162 305.85H256.201V342.842H279.162V305.85Z"
            fill="#86B361"
          />
          <path
            id="Vector"
            d="M279.163 305.85H256.202V342.842H279.163V305.85Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.01"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.01' in exhibitorLocations}
            data-booth="1.01"
            opacity="0.4"
            d="M218.05 375.524H195.089V412.516H218.05V375.524Z"
            fill="#86B361"
          />
          <path
            id="Vector_2"
            d="M218.05 375.525H195.089V412.517H218.05V375.525Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.08"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.08' in exhibitorLocations}
            data-booth="1.08"
            opacity="0.4"
            d="M218.05 197.385H195.089V234.377H218.05V197.385Z"
            fill="#86B361"
          />
          <path
            id="Vector_3"
            d="M218.05 197.385H195.089V234.377H218.05V197.385Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.16"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.16' in exhibitorLocations}
            data-booth="1.16"
            opacity="0.4"
            d="M288.82 153.38H251.828V176.341H288.82V153.38Z"
            fill="#86B361"
          />
          <path
            id="Vector_4"
            d="M288.82 153.38H251.828V176.341H288.82V153.38Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.15"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.15' in exhibitorLocations}
            data-booth="1.15"
            opacity="0.4"
            d="M252.139 153.38H215.147V176.341H252.139V153.38Z"
            fill="#86B361"
          />
          <path
            id="Vector_5"
            d="M252.139 153.38H215.147V176.341H252.139V153.38Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.14"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.14' in exhibitorLocations}
            data-booth="1.14"
            opacity="0.4"
            d="M312.686 211.408H256.203V234.74H312.686V211.408Z"
            fill="#86B361"
          />
          <path
            id="Vector_6"
            d="M312.687 211.409H256.204V234.741H312.687V211.409Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.13"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.13' in exhibitorLocations}
            data-booth="1.13"
            opacity="0.4"
            d="M279.195 234.939H256.234V258.525H279.195V234.939Z"
            fill="#86B361"
          />
          <path
            id="Vector_7"
            d="M279.195 234.94H256.234V258.526H279.195V234.94Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.07"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.07' in exhibitorLocations}
            data-booth="1.07"
            opacity="0.4"
            d="M218.049 234.172H195.058V257.504H218.049V234.172Z"
            fill="#86B361"
          />
          <path
            id="Vector_8"
            d="M218.05 234.172H195.059V257.504H218.05V234.172Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.06"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.06' in exhibitorLocations}
            data-booth="1.06"
            opacity="0.4"
            d="M218.05 257.703H195.089V281.289H218.05V257.703Z"
            fill="#86B361"
          />
          <path
            id="Vector_9"
            d="M218.05 257.703H195.089V281.289H218.05V257.703Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.05"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.05' in exhibitorLocations}
            data-booth="1.05"
            opacity="0.4"
            d="M218.049 281.289H195.058V304.622H218.049V281.289Z"
            fill="#86B361"
          />
          <path
            id="Vector_10"
            d="M218.05 281.289H195.059V304.622H218.05V281.289Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.04"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.04' in exhibitorLocations}
            data-booth="1.04"
            opacity="0.4"
            d="M218.05 304.821H195.089V328.407H218.05V304.821Z"
            fill="#86B361"
          />
          <path
            id="Vector_11"
            d="M218.05 304.821H195.089V328.407H218.05V304.821Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.12"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.12' in exhibitorLocations}
            data-booth="1.12"
            opacity="0.4"
            d="M279.195 258.678H256.234V282.264H279.195V258.678Z"
            fill="#86B361"
          />
          <path
            id="Vector_12"
            d="M279.195 258.678H256.234V282.264H279.195V258.678Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.11"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.11' in exhibitorLocations}
            data-booth="1.11"
            opacity="0.4"
            d="M279.195 282.264H256.234V305.85H279.195V282.264Z"
            fill="#86B361"
          />
          <path
            id="Vector_13"
            d="M279.195 282.264H256.234V305.85H279.195V282.264Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.09"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.09' in exhibitorLocations}
            data-booth="1.09"
            opacity="0.4"
            d="M279.195 342.978H256.234V366.564H279.195V342.978Z"
            fill="#86B361"
          />
          <path
            id="Vector_14"
            d="M279.195 342.978H256.234V366.564H279.195V342.978Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.08"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.08' in exhibitorLocations}
            data-booth="2.08"
            opacity="0.4"
            d="M401.229 441.402H368.701V466.913H401.229V441.402Z"
            fill="#F9B119"
          />
          <path
            id="Vector_15"
            d="M401.23 441.402H368.702V466.913H401.23V441.402Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.10"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.10' in exhibitorLocations}
            data-booth="2.10"
            opacity="0.4"
            d="M466.94 441.402H401.229V466.914H466.94V441.402Z"
            fill="#F9B119"
          />
          <path
            id="Vector_16"
            d="M466.941 441.402H401.23V466.914H466.941V441.402Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.12"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.12' in exhibitorLocations}
            data-booth="2.12"
            opacity="0.4"
            d="M510.946 441.403H466.94V466.913H510.946V441.403Z"
            fill="#F9B119"
          />
          <path
            id="Vector_17"
            d="M510.946 441.402H466.94V466.913H510.946V441.402Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.14"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.14' in exhibitorLocations}
            data-booth="2.14"
            opacity="0.4"
            d="M543.575 441.403H510.946V466.913H543.575V441.403Z"
            fill="#F9B119"
          />
          <path
            id="Vector_18"
            d="M543.576 441.402H510.947V466.913H543.576V441.402Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.15"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.15' in exhibitorLocations}
            data-booth="2.15"
            opacity="0.4"
            d="M603.67 409.391H578.159V441.919H603.67V409.391Z"
            fill="#F9B119"
          />
          <path
            id="Vector_19"
            d="M603.671 409.392H578.16V441.92H603.671V409.392Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.16"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.16' in exhibitorLocations}
            data-booth="2.16"
            opacity="0.4"
            d="M601.28 348.256H568.752V377.204H601.28V348.256Z"
            fill="#F9B119"
          />
          <path
            id="Vector_20"
            d="M601.28 348.256H568.752V377.204H601.28V348.256Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.23"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.23' in exhibitorLocations}
            data-booth="2.23"
            opacity="0.4"
            d="M590.598 330.035H568.752V348.255H590.598V330.035Z"
            fill="#F9B119"
          />
          <path
            id="Vector_21"
            d="M590.598 330.035H568.752V348.256H590.598V330.035Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.19"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.19' in exhibitorLocations}
            data-booth="2.19"
            opacity="0.4"
            d="M627.07 330.035H605.464V377.204H627.07V330.035Z"
            fill="#F9B119"
          />
          <path
            id="Vector_22"
            d="M627.071 330.035H605.465V377.204H627.071V330.035Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.21"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.21' in exhibitorLocations}
            data-booth="2.21"
            opacity="0.4"
            d="M600.076 266.021H569.121V298.893H600.076V266.021Z"
            fill="#F9B119"
          />
          <path
            id="Vector_23"
            d="M600.076 266.021H569.121V298.893H600.076V266.021Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.20"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.20' in exhibitorLocations}
            data-booth="2.20"
            opacity="0.4"
            d="M643.335 266.02H610.807V291.531H643.335V266.02Z"
            fill="#F9B119"
          />
          <path
            id="Vector_24"
            d="M643.335 266.02H610.807V291.531H643.335V266.02Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.17"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.17' in exhibitorLocations}
            data-booth="2.17"
            opacity="0.4"
            d="M711.544 357.961H686.033V427.944H711.544V357.961Z"
            fill="#F9B119"
          />
          <path
            id="Vector_25"
            d="M711.545 357.961H686.034V427.944H711.545V357.961Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.18"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.18' in exhibitorLocations}
            data-booth="2.18"
            opacity="0.4"
            d="M711.544 287.979H686.033V357.961H711.544V287.979Z"
            fill="#F9B119"
          />
          <path
            id="Vector_26"
            d="M711.545 287.979H686.034V357.962H711.545V287.979Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.22"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.22' in exhibitorLocations}
            data-booth="2.22"
            opacity="0.4"
            d="M538.073 239.268H505.545V264.779H538.073V239.268Z"
            fill="#F9B119"
          />
          <path
            id="Vector_27"
            d="M538.073 239.268H505.545V264.779H538.073V239.268Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.28"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.28' in exhibitorLocations}
            data-booth="2.28"
            opacity="0.4"
            d="M477.398 239.134H451.887V271.662H477.398V239.134Z"
            fill="#F9B119"
          />
          <path
            id="Vector_28"
            d="M477.398 239.134H451.887V271.662H477.398V239.134Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.27"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.27' in exhibitorLocations}
            data-booth="2.27"
            opacity="0.4"
            d="M452.629 301.74H427.118V334.478H452.629V301.74Z"
            fill="#F9B119"
          />
          <path
            id="Vector_29"
            d="M452.629 301.741H427.118V334.478H452.629V301.741Z"
            stroke="#F9B119"
            strokeWidth="0.993"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.26"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.26' in exhibitorLocations}
            data-booth="2.26"
            opacity="0.4"
            d="M478.472 334.739H452.961V360.25H478.472V334.739Z"
            fill="#F9B119"
          />
          <path
            id="Vector_30"
            d="M478.473 334.739H452.962V360.25H478.473V334.739Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.25"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.25' in exhibitorLocations}
            data-booth="2.25"
            opacity="0.4"
            d="M504.089 334.739H478.578V360.25H504.089V334.739Z"
            fill="#F9B119"
          />
          <path
            id="Vector_31"
            d="M504.089 334.739H478.578V360.25H504.089V334.739Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.24"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.24' in exhibitorLocations}
            data-booth="2.24"
            opacity="0.4"
            d="M562.889 334.749H504.089V360.26H562.889V334.749Z"
            fill="#F9B119"
          />
          <path
            id="Vector_32"
            d="M562.89 334.749H504.09V360.26H562.89V334.749Z"
            stroke="#F9B119"
            strokeWidth="0.875"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.05"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.05' in exhibitorLocations}
            data-booth="2.05"
            opacity="0.4"
            d="M401.229 360.261H368.383V414.473H401.229V360.261Z"
            fill="#F9B119"
          />
          <path
            id="Vector_33"
            d="M401.23 360.261H368.384V414.473H401.23V360.261Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.09"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.09' in exhibitorLocations}
            data-booth="2.09"
            opacity="0.4"
            d="M439.852 379.75H401.23V414.473H439.852V379.75Z"
            fill="#F9B119"
          />
          <path
            id="Vector_34"
            d="M439.852 379.75H401.23V414.473H439.852V379.75Z"
            stroke="#F9B119"
            strokeWidth="0.989"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.13"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.13' in exhibitorLocations}
            data-booth="2.13"
            opacity="0.4"
            d="M562.88 360.261H478.569V414.473H562.88V360.261Z"
            fill="#F9B119"
          />
          <path
            id="Vector_35"
            d="M562.88 360.261H478.569V414.473H562.88V360.261Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.04"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.04' in exhibitorLocations}
            data-booth="2.04"
            opacity="0.4"
            d="M427.118 295.205H368.383V360.26H427.118V295.205Z"
            fill="#F9B119"
          />
          <path
            id="Vector_36"
            d="M427.118 295.205H368.383V360.26H427.118V295.205Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_3.03"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'3.03' in exhibitorLocations}
            data-booth="3.03"
            opacity="0.2"
            d="M96.703 194.912H33.091V258.525H96.703V194.912Z"
            fill="#E30613"
          />
          <path
            id="Vector_37"
            d="M96.7039 194.913H33.0909V258.526H96.7039V194.913Z"
            stroke="#E30613"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_3.04"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'3.04' in exhibitorLocations}
            data-booth="3.04"
            opacity="0.2"
            d="M160.153 194.912H96.54V258.525H160.153V194.912Z"
            fill="#E30613"
          />
          <path
            id="Vector_38"
            d="M160.153 194.913H96.54V258.526H160.153V194.913Z"
            stroke="#E30613"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_3.01"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'3.01' in exhibitorLocations}
            data-booth="3.01"
            opacity="0.2"
            d="M96.841 349.674H33.229V413.287H96.841V349.674Z"
            fill="#E30613"
          />
          <path
            id="Vector_39"
            d="M96.8416 349.674H33.2286V413.287H96.8416V349.674Z"
            stroke="#E30613"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_3.02"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'3.02' in exhibitorLocations}
            data-booth="3.02"
            opacity="0.2"
            d="M160.289 349.674H96.677V413.287H160.289V349.674Z"
            fill="#E30613"
          />
          <path
            id="Vector_40"
            d="M160.291 349.674H96.6777V413.287H160.291V349.674Z"
            stroke="#E30613"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <g id="Clip path group">
            <g id="Group">
              <g id="Group_2" opacity="0.399994">
                <g id="Clip path group_2">
                  <mask
                    id="mask0_2_1031"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x={482}
                    y={150}
                    width={27}
                    height={52}
                  >
                    <g id="clippath-81">
                      <path id="Vector_41" d="M508.06 150.876H482.548V201.9H508.06V150.876Z" fill="white" />
                    </g>
                  </mask>
                  <g mask="url(#mask0_2_1031)">
                    <g id="Group_3">
                      <path id="Vector_42" d="M508.059 150.875H482.548V201.899H508.059V150.875Z" fill="#D0D4D7" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
            id="Vector_43"
            d="M508.06 150.875H482.549V201.9H508.06V150.875Z"
            stroke="#D0D4D7"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.18"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.18' in exhibitorLocations}
            data-booth="1.18"
            opacity="0.4"
            d="M426.078 152.347H363.744V202.248H426.078V152.347Z"
            fill="#86B361"
          />
          <path
            id="Vector_44"
            d="M426.079 152.348H363.745V202.248H426.079V152.348Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.17"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.17' in exhibitorLocations}
            data-booth="1.17"
            opacity="0.4"
            d="M363.744 168.025H335.842V202.248H363.744V168.025Z"
            fill="#86B361"
          />
          <path
            id="Vector_45"
            d="M363.745 168.025H335.843V202.248H363.745V168.025Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.02"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.02' in exhibitorLocations}
            data-booth="2.02"
            opacity="0.4"
            d="M391.38 236.882H344.227V262.393H391.38V236.882Z"
            fill="#F9B119"
          />
          <path
            id="Vector_46"
            d="M391.38 236.882H344.227V262.393H391.38V236.882Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.01"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.01' in exhibitorLocations}
            data-booth="2.01"
            opacity="0.4"
            d="M423.908 236.882H391.38V262.393H423.908V236.882Z"
            fill="#F9B119"
          />
          <path
            id="Vector_47"
            d="M423.908 236.882H391.38V262.393H423.908V236.882Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.03"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.03' in exhibitorLocations}
            data-booth="2.03"
            opacity="0.4"
            d="M337.167 268.329H311.656V333.384H337.167V268.329Z"
            fill="#F9B119"
          />
          <path
            id="Vector_48"
            d="M337.167 268.329H311.656V333.384H337.167V268.329Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.07"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.07' in exhibitorLocations}
            data-booth="2.07"
            opacity="0.4"
            d="M337.167 418.132H311.656V443.711H337.167V418.132Z"
            fill="#F9B119"
          />
          <path
            id="Vector_49"
            d="M337.167 418.132H311.656V443.712H337.167V418.132Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_2.06"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.06' in exhibitorLocations}
            data-booth="2.06"
            opacity="0.4"
            d="M337.167 377.368H311.656V418.131H337.167V377.368Z"
            fill="#F9B119"
          />
          <path
            id="Vector_50"
            d="M337.167 377.369H311.656V418.132H337.167V377.369Z"
            stroke="#F9B119"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_51"
            d="M345.24 183.048L344.17 183.743L343.712 183.025L345.348 181.725H346.265V186.679H345.24V183.048Z"
            fill="#86B361"
          />
          <path
            id="Vector_52"
            d="M347.476 186.159C347.476 185.815 347.743 185.555 348.079 185.555C348.424 185.555 348.692 185.815 348.692 186.159C348.692 186.488 348.424 186.756 348.079 186.756C347.736 186.756 347.476 186.488 347.476 186.159Z"
            fill="#86B361"
          />
          <path
            id="Vector_53"
            d="M351.001 183.048L349.931 183.743L349.473 183.025L351.109 181.725H352.026V186.679H351.001V183.048Z"
            fill="#86B361"
          />
          <path
            id="Vector_54"
            d="M355.736 182.635H353.128V181.725H356.92V182.367L354.825 186.679H353.709L355.736 182.635Z"
            fill="#86B361"
          />
          <path
            id="Vector_55"
            d="M265.268 164.397L264.198 165.092L263.74 164.374L265.375 163.074H266.292V168.028H265.268V164.397Z"
            fill="#86B361"
          />
          <path
            id="Vector_56"
            d="M267.503 167.508C267.503 167.164 267.771 166.904 268.107 166.904C268.451 166.904 268.719 167.164 268.719 167.508C268.719 167.837 268.451 168.105 268.107 168.105C267.763 168.105 267.503 167.837 267.503 167.508Z"
            fill="#86B361"
          />
          <path
            id="Vector_57"
            d="M271.029 164.397L269.958 165.092L269.5 164.374L271.136 163.074H272.053V168.028H271.029V164.397Z"
            fill="#86B361"
          />
          <path
            id="Vector_58"
            d="M273.24 166.346C273.24 165.872 273.415 165.391 273.714 164.993L275.22 162.967L276.031 163.518L275.166 164.657C275.212 164.649 275.274 164.641 275.312 164.641C276.282 164.641 276.993 165.383 276.993 166.293C276.993 167.317 276.282 168.105 275.113 168.105C273.944 168.105 273.24 167.348 273.24 166.346ZM275.923 166.339C275.923 165.88 275.602 165.505 275.113 165.505C274.615 165.505 274.31 165.88 274.31 166.339C274.31 166.828 274.601 167.202 275.113 167.202C275.617 167.202 275.923 166.828 275.923 166.339Z"
            fill="#86B361"
          />
          <path
            id="Vector_59"
            d="M228.586 164.397L227.516 165.092L227.058 164.374L228.694 163.074H229.611V168.028H228.586V164.397Z"
            fill="#86B361"
          />
          <path
            id="Vector_60"
            d="M230.822 167.508C230.822 167.164 231.089 166.904 231.425 166.904C231.77 166.904 232.037 167.164 232.037 167.508C232.037 167.837 231.77 168.105 231.425 168.105C231.081 168.105 230.822 167.837 230.822 167.508Z"
            fill="#86B361"
          />
          <path
            id="Vector_61"
            d="M234.347 164.397L233.277 165.092L232.819 164.374L234.454 163.074H235.371V168.028H234.347V164.397Z"
            fill="#86B361"
          />
          <path
            id="Vector_62"
            d="M236.65 167.6L237.04 166.843C237.308 167.057 237.789 167.225 238.209 167.225C238.898 167.225 239.219 166.843 239.219 166.43C239.219 165.903 238.737 165.643 238.125 165.643C237.774 165.643 237.43 165.773 237.216 165.895L236.841 165.551V163.074H239.998V163.984H237.865V164.894C238.041 164.84 238.24 164.81 238.447 164.81C239.433 164.81 240.281 165.345 240.281 166.377C240.281 167.439 239.455 168.105 238.24 168.105C237.56 168.105 237.025 167.898 236.65 167.6Z"
            fill="#86B361"
          />
          <path
            id="Vector_63"
            d="M262.667 323.961L261.597 324.656L261.139 323.938L262.775 322.638H263.692V327.592H262.667V323.961Z"
            fill="#86B361"
          />
          <path
            id="Vector_64"
            d="M264.903 327.072C264.903 326.728 265.17 326.468 265.506 326.468C265.851 326.468 266.118 326.728 266.118 327.072C266.118 327.401 265.851 327.668 265.506 327.668C265.162 327.668 264.903 327.401 264.903 327.072Z"
            fill="#86B361"
          />
          <path
            id="Vector_65"
            d="M268.428 323.961L267.358 324.656L266.9 323.938L268.535 322.638H269.452V327.592H268.428V323.961Z"
            fill="#86B361"
          />
          <path
            id="Vector_66"
            d="M270.609 325.115C270.609 323.616 271.419 322.562 272.589 322.562C273.75 322.562 274.561 323.616 274.561 325.115C274.561 326.613 273.75 327.668 272.589 327.668C271.419 327.668 270.609 326.613 270.609 325.115ZM273.49 325.115C273.49 324.152 273.185 323.479 272.589 323.479C271.985 323.479 271.671 324.152 271.671 325.115C271.671 326.078 271.985 326.751 272.589 326.751C273.185 326.751 273.49 326.078 273.49 325.115Z"
            fill="#86B361"
          />
          <path
            id="Vector_67"
            d="M201.252 268.842L200.182 269.538L199.724 268.82L201.36 267.52H202.277V272.474H201.252V268.842Z"
            fill="#86B361"
          />
          <path
            id="Vector_68"
            d="M203.488 271.954C203.488 271.61 203.755 271.35 204.091 271.35C204.436 271.35 204.703 271.61 204.703 271.954C204.703 272.283 204.436 272.55 204.091 272.55C203.747 272.55 203.488 272.283 203.488 271.954Z"
            fill="#86B361"
          />
          <path
            id="Vector_69"
            d="M205.369 269.997C205.369 268.499 206.18 267.444 207.35 267.444C208.511 267.444 209.322 268.499 209.322 269.997C209.322 271.495 208.511 272.55 207.35 272.55C206.18 272.55 205.369 271.495 205.369 269.997ZM208.251 269.997C208.251 269.034 207.946 268.361 207.35 268.361C206.745 268.361 206.432 269.034 206.432 269.997C206.432 270.96 206.745 271.633 207.35 271.633C207.946 271.633 208.251 270.96 208.251 269.997Z"
            fill="#86B361"
          />
          <path
            id="Vector_70"
            d="M209.958 270.792C209.958 270.318 210.134 269.837 210.433 269.439L211.939 267.413L212.749 267.964L211.885 269.103C211.931 269.095 211.992 269.087 212.031 269.087C213.001 269.087 213.712 269.829 213.712 270.738C213.712 271.763 213.001 272.55 211.831 272.55C210.662 272.55 209.958 271.794 209.958 270.792ZM212.642 270.784C212.642 270.326 212.321 269.951 211.831 269.951C211.334 269.951 211.029 270.326 211.029 270.784C211.029 271.274 211.32 271.648 211.831 271.648C212.336 271.648 212.642 271.274 212.642 270.784Z"
            fill="#86B361"
          />
          <path
            id="Vector_71"
            d="M263.929 246.007L262.859 246.703L262.401 245.984L264.036 244.685H264.953V249.638H263.929V246.007Z"
            fill="#86B361"
          />
          <path
            id="Vector_72"
            d="M266.164 249.118C266.164 248.775 266.432 248.515 266.768 248.515C267.113 248.515 267.38 248.775 267.38 249.118C267.38 249.447 267.113 249.715 266.768 249.715C266.424 249.715 266.164 249.447 266.164 249.118Z"
            fill="#86B361"
          />
          <path
            id="Vector_73"
            d="M269.69 246.007L268.619 246.703L268.161 245.984L269.797 244.685H270.714V249.638H269.69V246.007Z"
            fill="#86B361"
          />
          <path
            id="Vector_74"
            d="M271.901 249.134L272.337 248.43C272.657 248.721 273.109 248.828 273.514 248.828C274.156 248.828 274.592 248.507 274.592 248.003C274.592 247.612 274.233 247.292 273.614 247.292C273.362 247.292 273.155 247.33 272.91 247.467L272.566 246.863L274.065 245.594H272.154V244.685H275.379V245.564L274.202 246.596C274.34 246.603 274.47 246.634 274.6 246.672C275.211 246.848 275.655 247.337 275.655 248.041C275.655 249.164 274.722 249.715 273.606 249.715C272.887 249.715 272.291 249.493 271.901 249.134Z"
            fill="#86B361"
          />
          <path
            id="Vector_75"
            d="M263.929 269.745L262.859 270.441L262.401 269.722L264.036 268.423H264.953V273.376H263.929V269.745Z"
            fill="#86B361"
          />
          <path
            id="Vector_76"
            d="M266.164 272.856C266.164 272.512 266.432 272.253 266.768 272.253C267.113 272.253 267.38 272.512 267.38 272.856C267.38 273.185 267.113 273.453 266.768 273.453C266.424 273.453 266.164 273.185 266.164 272.856Z"
            fill="#86B361"
          />
          <path
            id="Vector_77"
            d="M269.69 269.745L268.619 270.441L268.161 269.722L269.797 268.423H270.714V273.376H269.69V269.745Z"
            fill="#86B361"
          />
          <path
            id="Vector_78"
            d="M271.901 272.719C273.575 271.365 274.34 270.578 274.34 269.936C274.34 269.577 274.103 269.271 273.614 269.271C273.3 269.271 272.903 269.424 272.497 269.791L271.978 269.118C272.581 268.461 273.323 268.346 273.698 268.346C274.638 268.346 275.417 268.866 275.417 269.844C275.417 270.785 274.47 271.779 273.552 272.466H275.571V273.376H271.901V272.719Z"
            fill="#86B361"
          />
          <path
            id="Vector_79"
            d="M264.235 293.33L263.164 294.026L262.706 293.307L264.342 292.007H265.259V296.961H264.235V293.33Z"
            fill="#86B361"
          />
          <path
            id="Vector_80"
            d="M266.47 296.442C266.47 296.097 266.738 295.837 267.073 295.837C267.418 295.837 267.686 296.097 267.686 296.442C267.686 296.77 267.418 297.037 267.073 297.037C266.73 297.037 266.47 296.77 266.47 296.442Z"
            fill="#86B361"
          />
          <path
            id="Vector_81"
            d="M269.995 293.33L268.925 294.026L268.467 293.307L270.103 292.007H271.02V296.961H269.995V293.33Z"
            fill="#86B361"
          />
          <path
            id="Vector_82"
            d="M273.82 293.33L272.749 294.026L272.291 293.307L273.927 292.007H274.844V296.961H273.82V293.33Z"
            fill="#86B361"
          />
          <path
            id="Vector_83"
            d="M263.562 354.041L262.491 354.737L262.033 354.018L263.669 352.718H264.586V357.672H263.562V354.041Z"
            fill="#86B361"
          />
          <path
            id="Vector_84"
            d="M265.797 357.153C265.797 356.808 266.065 356.548 266.401 356.548C266.745 356.548 267.013 356.808 267.013 357.153C267.013 357.481 266.745 357.748 266.401 357.748C266.057 357.748 265.797 357.481 265.797 357.153Z"
            fill="#86B361"
          />
          <path
            id="Vector_85"
            d="M267.679 355.195C267.679 353.696 268.49 352.642 269.659 352.642C270.821 352.642 271.631 353.696 271.631 355.195C271.631 356.694 270.821 357.748 269.659 357.748C268.49 357.748 267.679 356.694 267.679 355.195ZM270.561 355.195C270.561 354.232 270.255 353.559 269.659 353.559C269.055 353.559 268.741 354.232 268.741 355.195C268.741 356.158 269.055 356.831 269.659 356.831C270.255 356.831 270.561 356.158 270.561 355.195Z"
            fill="#86B361"
          />
          <path
            id="Vector_86"
            d="M276.022 354.401C276.022 354.874 275.846 355.356 275.548 355.753L274.042 357.779L273.232 357.229L274.095 356.09C274.049 356.097 273.989 356.105 273.95 356.105C272.979 356.105 272.268 355.363 272.268 354.453C272.268 353.429 272.979 352.642 274.149 352.642C275.319 352.642 276.022 353.399 276.022 354.401ZM273.338 354.407C273.338 354.866 273.659 355.241 274.149 355.241C274.646 355.241 274.951 354.866 274.951 354.407C274.951 353.918 274.661 353.544 274.149 353.544C273.645 353.544 273.338 353.918 273.338 354.407Z"
            fill="#86B361"
          />
          <path
            id="Vector_87"
            d="M279.268 220.991L278.198 221.687L277.74 220.968L279.375 219.669H280.292V224.623H279.268V220.991Z"
            fill="#86B361"
          />
          <path
            id="Vector_88"
            d="M281.503 224.103C281.503 223.759 281.771 223.499 282.107 223.499C282.451 223.499 282.719 223.759 282.719 224.103C282.719 224.432 282.451 224.699 282.107 224.699C281.763 224.699 281.503 224.432 281.503 224.103Z"
            fill="#86B361"
          />
          <path
            id="Vector_89"
            d="M285.029 220.991L283.958 221.687L283.5 220.968L285.136 219.669H286.053V224.623H285.029V220.991Z"
            fill="#86B361"
          />
          <path
            id="Vector_90"
            d="M289.617 223.667H287.285V222.971L289.144 219.516L289.999 219.944L288.486 222.758H289.617V221.679H290.604V222.758H291.193V223.667H290.604V224.623H289.617V223.667Z"
            fill="#86B361"
          />
          <path
            id="Vector_91"
            d="M200.579 214.627L199.509 215.322L199.051 214.604L200.687 213.304H201.604V218.258H200.579V214.627Z"
            fill="#86B361"
          />
          <path
            id="Vector_92"
            d="M202.815 217.738C202.815 217.394 203.082 217.134 203.418 217.134C203.763 217.134 204.031 217.394 204.031 217.738C204.031 218.067 203.763 218.335 203.418 218.335C203.074 218.335 202.815 218.067 202.815 217.738Z"
            fill="#86B361"
          />
          <path
            id="Vector_93"
            d="M204.697 215.781C204.697 214.283 205.507 213.228 206.677 213.228C207.838 213.228 208.649 214.283 208.649 215.781C208.649 217.279 207.838 218.335 206.677 218.335C205.507 218.335 204.697 217.279 204.697 215.781ZM207.578 215.781C207.578 214.818 207.273 214.145 206.677 214.145C206.073 214.145 205.759 214.818 205.759 215.781C205.759 216.744 206.073 217.417 206.677 217.417C207.273 217.417 207.578 216.744 207.578 215.781Z"
            fill="#86B361"
          />
          <path
            id="Vector_94"
            d="M209.263 216.813C209.263 216.278 209.538 215.812 210.066 215.59C209.729 215.368 209.561 215.009 209.561 214.566C209.561 213.809 210.165 213.228 211.166 213.228C212.16 213.228 212.764 213.809 212.764 214.566C212.764 215.009 212.596 215.368 212.26 215.59C212.787 215.812 213.063 216.278 213.063 216.813C213.063 217.715 212.344 218.342 211.166 218.342C209.982 218.342 209.263 217.715 209.263 216.813ZM211.985 216.721C211.985 216.316 211.701 215.98 211.166 215.98C210.623 215.98 210.341 216.316 210.341 216.721C210.341 217.127 210.639 217.44 211.166 217.44C211.694 217.44 211.985 217.127 211.985 216.721ZM211.823 214.688C211.823 214.359 211.587 214.084 211.166 214.084C210.739 214.084 210.509 214.359 210.509 214.688C210.509 215.009 210.723 215.299 211.166 215.299C211.602 215.299 211.823 215.009 211.823 214.688Z"
            fill="#86B361"
          />
          <path
            id="Vector_95"
            d="M201.773 243.758L200.702 244.454L200.244 243.735L201.88 242.436H202.797V247.389H201.773V243.758Z"
            fill="#86B361"
          />
          <path
            id="Vector_96"
            d="M204.008 246.869C204.008 246.526 204.276 246.266 204.612 246.266C204.956 246.266 205.224 246.526 205.224 246.869C205.224 247.198 204.956 247.466 204.612 247.466C204.268 247.466 204.008 247.198 204.008 246.869Z"
            fill="#86B361"
          />
          <path
            id="Vector_97"
            d="M205.89 244.912C205.89 243.414 206.7 242.359 207.87 242.359C209.031 242.359 209.842 243.414 209.842 244.912C209.842 246.411 209.031 247.466 207.87 247.466C206.7 247.466 205.89 246.411 205.89 244.912ZM208.772 244.912C208.772 243.949 208.466 243.277 207.87 243.277C207.266 243.277 206.952 243.949 206.952 244.912C206.952 245.876 207.266 246.549 207.87 246.549C208.466 246.549 208.772 245.876 208.772 244.912Z"
            fill="#86B361"
          />
          <path
            id="Vector_98"
            d="M213.002 243.345H210.395V242.436H214.187V243.078L212.092 247.389H210.976L213.002 243.345Z"
            fill="#86B361"
          />
          <path
            id="Vector_99"
            d="M200.465 315.883L199.395 316.578L198.937 315.86L200.573 314.56H201.49V319.514H200.465V315.883Z"
            fill="#86B361"
          />
          <path
            id="Vector_100"
            d="M202.7 318.994C202.7 318.65 202.968 318.39 203.304 318.39C203.649 318.39 203.916 318.65 203.916 318.994C203.916 319.322 203.649 319.59 203.304 319.59C202.96 319.59 202.7 319.322 202.7 318.994Z"
            fill="#86B361"
          />
          <path
            id="Vector_101"
            d="M204.582 317.037C204.582 315.538 205.393 314.484 206.563 314.484C207.724 314.484 208.534 315.538 208.534 317.037C208.534 318.535 207.724 319.59 206.563 319.59C205.393 319.59 204.582 318.535 204.582 317.037ZM207.464 317.037C207.464 316.073 207.158 315.401 206.563 315.401C205.958 315.401 205.645 316.073 205.645 317.037C205.645 318 205.958 318.673 206.563 318.673C207.158 318.673 207.464 318 207.464 317.037Z"
            fill="#86B361"
          />
          <path
            id="Vector_102"
            d="M211.549 318.558H209.217V317.862L211.075 314.407L211.931 314.835L210.417 317.649H211.549V316.57H212.535V317.649H213.124V318.558H212.535V319.514H211.549V318.558Z"
            fill="#86B361"
          />
          <path
            id="Vector_103"
            d="M201.697 291.778L200.626 292.473L200.168 291.754L201.804 290.454H202.721V295.408H201.697V291.778Z"
            fill="#86B361"
          />
          <path
            id="Vector_104"
            d="M203.932 294.889C203.932 294.544 204.199 294.284 204.535 294.284C204.88 294.284 205.148 294.544 205.148 294.889C205.148 295.217 204.88 295.485 204.535 295.485C204.192 295.485 203.932 295.217 203.932 294.889Z"
            fill="#86B361"
          />
          <path
            id="Vector_105"
            d="M205.814 292.932C205.814 291.433 206.624 290.378 207.794 290.378C208.955 290.378 209.766 291.433 209.766 292.932C209.766 294.43 208.955 295.485 207.794 295.485C206.624 295.485 205.814 294.43 205.814 292.932ZM208.696 292.932C208.696 291.968 208.39 291.295 207.794 291.295C207.19 291.295 206.876 291.968 206.876 292.932C206.876 293.895 207.19 294.568 207.794 294.568C208.39 294.568 208.696 293.895 208.696 292.932Z"
            fill="#86B361"
          />
          <path
            id="Vector_106"
            d="M210.494 294.981L210.885 294.224C211.153 294.438 211.634 294.606 212.054 294.606C212.742 294.606 213.064 294.224 213.064 293.811C213.064 293.283 212.581 293.024 211.97 293.024C211.618 293.024 211.275 293.154 211.061 293.276L210.686 292.932V290.454H213.843V291.364H211.71V292.274C211.886 292.221 212.085 292.19 212.291 292.19C213.278 292.19 214.126 292.725 214.126 293.757C214.126 294.82 213.3 295.485 212.085 295.485C211.405 295.485 210.869 295.279 210.494 294.981Z"
            fill="#86B361"
          />
          <path
            id="BOOTH_1.03"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.03' in exhibitorLocations}
            data-booth="1.03"
            opacity="0.4"
            d="M218.049 328.406H195.058V351.739H218.049V328.406Z"
            fill="#86B361"
          />
          <path
            id="Vector_107"
            d="M218.05 328.407H195.059V351.74H218.05V328.407Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="BOOTH_1.02"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'1.02' in exhibitorLocations}
            data-booth="1.02"
            opacity="0.4"
            d="M218.05 351.938H195.089V375.524H218.05V351.938Z"
            fill="#86B361"
          />
          <path
            id="Vector_108"
            d="M218.05 351.939H195.089V375.525H218.05V351.939Z"
            stroke="#86B361"
            strokeWidth="0.9"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_109"
            d="M200.578 363.005L199.508 363.7L199.05 362.982L200.686 361.682H201.603V366.636H200.578V363.005Z"
            fill="#86B361"
          />
          <path
            id="Vector_110"
            d="M202.814 366.116C202.814 365.772 203.081 365.512 203.417 365.512C203.762 365.512 204.03 365.772 204.03 366.116C204.03 366.445 203.762 366.712 203.417 366.712C203.073 366.712 202.814 366.445 202.814 366.116Z"
            fill="#86B361"
          />
          <path
            id="Vector_111"
            d="M204.696 364.159C204.696 362.66 205.506 361.606 206.676 361.606C207.837 361.606 208.648 362.66 208.648 364.159C208.648 365.657 207.837 366.712 206.676 366.712C205.506 366.712 204.696 365.657 204.696 364.159ZM207.577 364.159C207.577 363.195 207.272 362.523 206.676 362.523C206.072 362.523 205.758 363.195 205.758 364.159C205.758 365.122 206.072 365.795 206.676 365.795C207.272 365.795 207.577 365.122 207.577 364.159Z"
            fill="#86B361"
          />
          <path
            id="Vector_112"
            d="M209.284 365.979C210.959 364.625 211.724 363.838 211.724 363.195C211.724 362.836 211.487 362.53 210.997 362.53C210.684 362.53 210.286 362.684 209.881 363.051L209.362 362.378C209.965 361.721 210.706 361.606 211.081 361.606C212.022 361.606 212.801 362.125 212.801 363.104C212.801 364.044 211.854 365.038 210.936 365.726H212.954V366.636H209.284V365.979Z"
            fill="#86B361"
          />
          <path
            id="Vector_113"
            d="M201.703 337.997L200.633 338.693L200.175 337.974L201.811 336.674H202.728V341.628H201.703V337.997Z"
            fill="#86B361"
          />
          <path
            id="Vector_114"
            d="M203.939 341.109C203.939 340.764 204.206 340.504 204.542 340.504C204.887 340.504 205.155 340.764 205.155 341.109C205.155 341.437 204.887 341.704 204.542 341.704C204.198 341.704 203.939 341.437 203.939 341.109Z"
            fill="#86B361"
          />
          <path
            id="Vector_115"
            d="M205.821 339.152C205.821 337.653 206.631 336.598 207.801 336.598C208.962 336.598 209.773 337.653 209.773 339.152C209.773 340.65 208.962 341.704 207.801 341.704C206.631 341.704 205.821 340.65 205.821 339.152ZM208.702 339.152C208.702 338.188 208.397 337.515 207.801 337.515C207.197 337.515 206.883 338.188 206.883 339.152C206.883 340.114 207.197 340.787 207.801 340.787C208.397 340.787 208.702 340.114 208.702 339.152Z"
            fill="#86B361"
          />
          <path
            id="Vector_116"
            d="M210.409 341.123L210.846 340.42C211.166 340.711 211.617 340.818 212.023 340.818C212.665 340.818 213.101 340.496 213.101 339.992C213.101 339.603 212.741 339.281 212.122 339.281C211.87 339.281 211.663 339.32 211.419 339.457L211.074 338.853L212.573 337.584H210.662V336.674H213.888V337.554L212.711 338.585C212.849 338.593 212.979 338.624 213.109 338.662C213.72 338.838 214.163 339.327 214.163 340.03C214.163 341.154 213.231 341.704 212.115 341.704C211.396 341.704 210.8 341.483 210.409 341.123Z"
            fill="#86B361"
          />
          <path
            id="Vector_117"
            d="M202.009 391.7L200.939 392.396L200.481 391.677L202.116 390.377H203.033V395.331H202.009V391.7Z"
            fill="#86B361"
          />
          <path
            id="Vector_118"
            d="M204.244 394.812C204.244 394.467 204.512 394.207 204.848 394.207C205.193 394.207 205.46 394.467 205.46 394.812C205.46 395.14 205.193 395.407 204.848 395.407C204.504 395.407 204.244 395.14 204.244 394.812Z"
            fill="#86B361"
          />
          <path
            id="Vector_119"
            d="M206.126 392.855C206.126 391.356 206.937 390.301 208.107 390.301C209.268 390.301 210.078 391.356 210.078 392.855C210.078 394.353 209.268 395.407 208.107 395.407C206.937 395.407 206.126 394.353 206.126 392.855ZM209.008 392.855C209.008 391.891 208.702 391.218 208.107 391.218C207.502 391.218 207.189 391.891 207.189 392.855C207.189 393.818 207.502 394.49 208.107 394.49C208.702 394.49 209.008 393.818 209.008 392.855Z"
            fill="#86B361"
          />
          <path
            id="Vector_120"
            d="M212.328 391.7L211.258 392.396L210.8 391.677L212.436 390.377H213.353V395.331H212.328V391.7Z"
            fill="#86B361"
          />
          <path
            id="Vector_121"
            d="M390.451 176.918L389.381 177.614L388.923 176.895L390.559 175.596H391.476V180.549H390.451V176.918Z"
            fill="#86B361"
          />
          <path
            id="Vector_122"
            d="M392.687 180.029C392.687 179.686 392.954 179.426 393.29 179.426C393.635 179.426 393.903 179.686 393.903 180.029C393.903 180.359 393.635 180.626 393.29 180.626C392.947 180.626 392.687 180.359 392.687 180.029Z"
            fill="#86B361"
          />
          <path
            id="Vector_123"
            d="M396.212 176.918L395.142 177.614L394.684 176.895L396.32 175.596H397.237V180.549H396.212V176.918Z"
            fill="#86B361"
          />
          <path
            id="Vector_124"
            d="M398.401 179.105C398.401 178.57 398.676 178.103 399.203 177.882C398.866 177.66 398.698 177.3 398.698 176.857C398.698 176.1 399.303 175.519 400.304 175.519C401.298 175.519 401.902 176.1 401.902 176.857C401.902 177.3 401.734 177.66 401.398 177.882C401.925 178.103 402.2 178.57 402.2 179.105C402.2 180.007 401.482 180.633 400.304 180.633C399.119 180.633 398.401 180.007 398.401 179.105ZM401.122 179.013C401.122 178.608 400.839 178.271 400.304 178.271C399.761 178.271 399.479 178.608 399.479 179.013C399.479 179.418 399.777 179.732 400.304 179.732C400.831 179.732 401.122 179.418 401.122 179.013ZM400.961 176.98C400.961 176.651 400.725 176.376 400.304 176.376C399.876 176.376 399.647 176.651 399.647 176.98C399.647 177.3 399.861 177.591 400.304 177.591C400.74 177.591 400.961 177.3 400.961 176.98Z"
            fill="#86B361"
          />
          <path
            id="Vector_125"
            d="M457.36 256.507C459.034 255.154 459.799 254.366 459.799 253.724C459.799 253.365 459.562 253.059 459.073 253.059C458.759 253.059 458.362 253.212 457.956 253.579L457.437 252.906C458.04 252.249 458.781 252.134 459.156 252.134C460.097 252.134 460.876 252.654 460.876 253.633C460.876 254.573 459.929 255.567 459.011 256.255H461.03V257.164H457.36V256.507Z"
            fill="#F6A200"
          />
          <path
            id="Vector_126"
            d="M461.82 256.644C461.82 256.3 462.087 256.041 462.423 256.041C462.768 256.041 463.035 256.3 463.035 256.644C463.035 256.973 462.768 257.241 462.423 257.241C462.079 257.241 461.82 256.973 461.82 256.644Z"
            fill="#F6A200"
          />
          <path
            id="Vector_127"
            d="M463.732 256.507C465.406 255.154 466.171 254.366 466.171 253.724C466.171 253.365 465.934 253.059 465.445 253.059C465.131 253.059 464.734 253.212 464.328 253.579L463.809 252.906C464.412 252.249 465.154 252.134 465.529 252.134C466.469 252.134 467.248 252.654 467.248 253.633C467.248 254.573 466.301 255.567 465.383 256.255H467.402V257.164H463.732V256.507Z"
            fill="#F6A200"
          />
          <path
            id="Vector_128"
            d="M468.147 255.719C468.147 255.184 468.422 254.718 468.949 254.496C468.613 254.275 468.445 253.915 468.445 253.472C468.445 252.715 469.049 252.134 470.05 252.134C471.044 252.134 471.648 252.715 471.648 253.472C471.648 253.915 471.48 254.275 471.144 254.496C471.671 254.718 471.947 255.184 471.947 255.719C471.947 256.621 471.228 257.248 470.05 257.248C468.865 257.248 468.147 256.621 468.147 255.719ZM470.868 255.628C470.868 255.222 470.585 254.886 470.05 254.886C469.507 254.886 469.225 255.222 469.225 255.628C469.225 256.033 469.523 256.346 470.05 256.346C470.577 256.346 470.868 256.033 470.868 255.628ZM470.707 253.594C470.707 253.265 470.471 252.99 470.05 252.99C469.622 252.99 469.393 253.265 469.393 253.594C469.393 253.915 469.607 254.206 470.05 254.206C470.486 254.206 470.707 253.915 470.707 253.594Z"
            fill="#F6A200"
          />
          <path
            id="Vector_129"
            d="M377.623 454.55C379.298 453.196 380.063 452.409 380.063 451.767C380.063 451.407 379.825 451.102 379.336 451.102C379.023 451.102 378.625 451.255 378.22 451.622L377.7 450.949C378.304 450.292 379.045 450.177 379.42 450.177C380.361 450.177 381.14 450.696 381.14 451.675C381.14 452.615 380.193 453.61 379.275 454.297H381.293V455.207H377.623V454.55Z"
            fill="#F6A200"
          />
          <path
            id="Vector_130"
            d="M382.083 454.688C382.083 454.343 382.351 454.083 382.687 454.083C383.031 454.083 383.299 454.343 383.299 454.688C383.299 455.016 383.031 455.283 382.687 455.283C382.343 455.283 382.083 455.016 382.083 454.688Z"
            fill="#F6A200"
          />
          <path
            id="Vector_131"
            d="M383.965 452.731C383.965 451.232 384.776 450.177 385.946 450.177C387.107 450.177 387.917 451.232 387.917 452.731C387.917 454.229 387.107 455.283 385.946 455.283C384.776 455.283 383.965 454.229 383.965 452.731ZM386.847 452.731C386.847 451.767 386.541 451.094 385.946 451.094C385.341 451.094 385.028 451.767 385.028 452.731C385.028 453.694 385.341 454.366 385.946 454.366C386.541 454.366 386.847 453.694 386.847 452.731Z"
            fill="#F6A200"
          />
          <path
            id="Vector_132"
            d="M388.532 453.762C388.532 453.228 388.808 452.761 389.335 452.539C388.998 452.318 388.83 451.958 388.83 451.515C388.83 450.758 389.435 450.177 390.436 450.177C391.43 450.177 392.033 450.758 392.033 451.515C392.033 451.958 391.865 452.318 391.53 452.539C392.057 452.761 392.332 453.228 392.332 453.762C392.332 454.664 391.614 455.291 390.436 455.291C389.251 455.291 388.532 454.664 388.532 453.762ZM391.254 453.671C391.254 453.266 390.971 452.929 390.436 452.929C389.893 452.929 389.611 453.266 389.611 453.671C389.611 454.075 389.908 454.389 390.436 454.389C390.963 454.389 391.254 454.075 391.254 453.671ZM391.093 451.637C391.093 451.309 390.857 451.033 390.436 451.033C390.008 451.033 389.779 451.309 389.779 451.637C389.779 451.958 389.992 452.249 390.436 452.249C390.871 452.249 391.093 451.958 391.093 451.637Z"
            fill="#F6A200"
          />
          <path
            id="Vector_133"
            d="M426.102 454.55C427.777 453.196 428.541 452.409 428.541 451.767C428.541 451.407 428.304 451.102 427.815 451.102C427.501 451.102 427.104 451.255 426.698 451.622L426.179 450.949C426.782 450.292 427.524 450.177 427.899 450.177C428.839 450.177 429.618 450.696 429.618 451.675C429.618 452.615 428.671 453.61 427.753 454.297H429.772V455.207H426.102V454.55Z"
            fill="#F6A200"
          />
          <path
            id="Vector_134"
            d="M430.562 454.688C430.562 454.343 430.829 454.083 431.165 454.083C431.51 454.083 431.778 454.343 431.778 454.688C431.778 455.016 431.51 455.283 431.165 455.283C430.822 455.283 430.562 455.016 430.562 454.688Z"
            fill="#F6A200"
          />
          <path
            id="Vector_135"
            d="M434.087 451.576L433.017 452.272L432.559 451.553L434.195 450.253H435.112V455.207H434.087V451.576Z"
            fill="#F6A200"
          />
          <path
            id="Vector_136"
            d="M436.269 452.731C436.269 451.232 437.079 450.177 438.249 450.177C439.41 450.177 440.221 451.232 440.221 452.731C440.221 454.229 439.41 455.283 438.249 455.283C437.079 455.283 436.269 454.229 436.269 452.731ZM439.151 452.731C439.151 451.767 438.845 451.094 438.249 451.094C437.645 451.094 437.331 451.767 437.331 452.731C437.331 453.694 437.645 454.366 438.249 454.366C438.845 454.366 439.151 453.694 439.151 452.731Z"
            fill="#F6A200"
          />
          <path
            id="Vector_137"
            d="M519.608 454.55C521.282 453.196 522.047 452.409 522.047 451.767C522.047 451.407 521.81 451.102 521.321 451.102C521.007 451.102 520.61 451.255 520.204 451.622L519.685 450.949C520.288 450.292 521.03 450.177 521.405 450.177C522.345 450.177 523.124 450.696 523.124 451.675C523.124 452.615 522.177 453.61 521.259 454.297H523.278V455.207H519.608V454.55Z"
            fill="#F6A200"
          />
          <path
            id="Vector_138"
            d="M524.068 454.688C524.068 454.343 524.335 454.083 524.671 454.083C525.016 454.083 525.283 454.343 525.283 454.688C525.283 455.016 525.016 455.283 524.671 455.283C524.327 455.283 524.068 455.016 524.068 454.688Z"
            fill="#F6A200"
          />
          <path
            id="Vector_139"
            d="M527.593 451.576L526.523 452.272L526.065 451.553L527.7 450.253H528.617V455.207H527.593V451.576Z"
            fill="#F6A200"
          />
          <path
            id="Vector_140"
            d="M532.183 454.251H529.851V453.556L531.709 450.101L532.565 450.529L531.051 453.342H532.183V452.264H533.169V453.342H533.758V454.251H533.169V455.207H532.183V454.251Z"
            fill="#F6A200"
          />
          <path
            id="Vector_141"
            d="M481.962 454.55C483.637 453.196 484.402 452.409 484.402 451.767C484.402 451.407 484.164 451.102 483.675 451.102C483.362 451.102 482.964 451.255 482.559 451.622L482.039 450.949C482.643 450.292 483.384 450.177 483.759 450.177C484.699 450.177 485.479 450.696 485.479 451.675C485.479 452.615 484.531 453.61 483.614 454.297H485.632V455.207H481.962V454.55Z"
            fill="#F6A200"
          />
          <path
            id="Vector_142"
            d="M486.422 454.688C486.422 454.343 486.69 454.083 487.026 454.083C487.37 454.083 487.638 454.343 487.638 454.688C487.638 455.016 487.37 455.283 487.026 455.283C486.682 455.283 486.422 455.016 486.422 454.688Z"
            fill="#F6A200"
          />
          <path
            id="Vector_143"
            d="M489.948 451.576L488.877 452.272L488.419 451.553L490.055 450.253H490.972V455.207H489.948V451.576Z"
            fill="#F6A200"
          />
          <path
            id="Vector_144"
            d="M492.159 454.55C493.834 453.196 494.599 452.409 494.599 451.767C494.599 451.407 494.362 451.102 493.872 451.102C493.559 451.102 493.161 451.255 492.756 451.622L492.237 450.949C492.84 450.292 493.581 450.177 493.956 450.177C494.897 450.177 495.676 450.696 495.676 451.675C495.676 452.615 494.729 453.61 493.811 454.297H495.829V455.207H492.159V454.55Z"
            fill="#F6A200"
          />
          <path
            id="Vector_145"
            d="M514.521 254.105C516.196 252.751 516.96 251.964 516.96 251.322C516.96 250.963 516.723 250.657 516.234 250.657C515.92 250.657 515.523 250.81 515.117 251.176L514.598 250.504C515.201 249.846 515.943 249.732 516.318 249.732C517.258 249.732 518.037 250.252 518.037 251.23C518.037 252.171 517.09 253.164 516.172 253.852H518.191V254.762H514.521V254.105Z"
            fill="#F6A200"
          />
          <path
            id="Vector_146"
            d="M518.981 254.242C518.981 253.898 519.248 253.638 519.584 253.638C519.929 253.638 520.197 253.898 520.197 254.242C520.197 254.571 519.929 254.839 519.584 254.839C519.24 254.839 518.981 254.571 518.981 254.242Z"
            fill="#F6A200"
          />
          <path
            id="Vector_147"
            d="M520.893 254.105C522.568 252.751 523.332 251.964 523.332 251.322C523.332 250.963 523.095 250.657 522.606 250.657C522.292 250.657 521.895 250.81 521.49 251.176L520.97 250.504C521.573 249.846 522.315 249.732 522.69 249.732C523.63 249.732 524.409 250.252 524.409 251.23C524.409 252.171 523.462 253.164 522.544 253.852H524.563V254.762H520.893V254.105Z"
            fill="#F6A200"
          />
          <path
            id="Vector_148"
            d="M525.33 254.105C527.005 252.751 527.77 251.964 527.77 251.322C527.77 250.963 527.532 250.657 527.043 250.657C526.73 250.657 526.332 250.81 525.927 251.176L525.407 250.504C526.011 249.846 526.752 249.732 527.127 249.732C528.068 249.732 528.847 250.252 528.847 251.23C528.847 252.171 527.9 253.164 526.982 253.852H529V254.762H525.33V254.105Z"
            fill="#F6A200"
          />
          <path
            id="Vector_149"
            d="M577.38 286.411C579.055 285.058 579.82 284.271 579.82 283.628C579.82 283.269 579.582 282.963 579.093 282.963C578.78 282.963 578.382 283.116 577.977 283.484L577.457 282.811C578.061 282.154 578.802 282.038 579.177 282.038C580.117 282.038 580.897 282.558 580.897 283.536C580.897 284.477 579.949 285.471 579.031 286.158H581.05V287.069H577.38V286.411Z"
            fill="#F6A200"
          />
          <path
            id="Vector_150"
            d="M581.84 286.549C581.84 286.204 582.108 285.945 582.444 285.945C582.788 285.945 583.056 286.204 583.056 286.549C583.056 286.877 582.788 287.145 582.444 287.145C582.1 287.145 581.84 286.877 581.84 286.549Z"
            fill="#F6A200"
          />
          <path
            id="Vector_151"
            d="M583.752 286.411C585.427 285.058 586.192 284.271 586.192 283.628C586.192 283.269 585.954 282.963 585.465 282.963C585.152 282.963 584.754 283.116 584.349 283.484L583.829 282.811C584.433 282.154 585.174 282.038 585.549 282.038C586.49 282.038 587.269 282.558 587.269 283.536C587.269 284.477 586.322 285.471 585.404 286.158H587.422V287.069H583.752V286.411Z"
            fill="#F6A200"
          />
          <path
            id="Vector_152"
            d="M589.803 283.438L588.733 284.133L588.275 283.414L589.91 282.114H590.827V287.069H589.803V283.438Z"
            fill="#F6A200"
          />
          <path
            id="Vector_153"
            d="M619.142 280.283C620.817 278.93 621.581 278.143 621.581 277.501C621.581 277.141 621.344 276.836 620.855 276.836C620.541 276.836 620.144 276.988 619.739 277.355L619.219 276.682C619.823 276.025 620.564 275.91 620.939 275.91C621.879 275.91 622.658 276.43 622.658 277.409C622.658 278.349 621.711 279.343 620.793 280.03H622.812V280.941H619.142V280.283Z"
            fill="#F6A200"
          />
          <path
            id="Vector_154"
            d="M623.602 280.421C623.602 280.076 623.869 279.817 624.205 279.817C624.55 279.817 624.818 280.076 624.818 280.421C624.818 280.749 624.55 281.017 624.205 281.017C623.862 281.017 623.602 280.749 623.602 280.421Z"
            fill="#F6A200"
          />
          <path
            id="Vector_155"
            d="M625.514 280.283C627.189 278.93 627.953 278.143 627.953 277.501C627.953 277.141 627.716 276.836 627.227 276.836C626.913 276.836 626.516 276.988 626.111 277.355L625.591 276.682C626.195 276.025 626.936 275.91 627.311 275.91C628.251 275.91 629.031 276.43 629.031 277.409C629.031 278.349 628.083 279.343 627.165 280.03H629.184V280.941H625.514V280.283Z"
            fill="#F6A200"
          />
          <path
            id="Vector_156"
            d="M629.921 278.464C629.921 276.966 630.732 275.91 631.902 275.91C633.063 275.91 633.873 276.966 633.873 278.464C633.873 279.962 633.063 281.017 631.902 281.017C630.732 281.017 629.921 279.962 629.921 278.464ZM632.803 278.464C632.803 277.501 632.497 276.828 631.902 276.828C631.297 276.828 630.984 277.501 630.984 278.464C630.984 279.427 631.297 280.1 631.902 280.1C632.497 280.1 632.803 279.427 632.803 278.464Z"
            fill="#F6A200"
          />
          <path
            id="Vector_157"
            d="M692.796 326.589C694.471 325.236 695.236 324.448 695.236 323.806C695.236 323.446 694.998 323.141 694.509 323.141C694.196 323.141 693.798 323.294 693.393 323.661L692.873 322.988C693.477 322.331 694.218 322.216 694.593 322.216C695.533 322.216 696.313 322.736 696.313 323.714C696.313 324.654 695.365 325.649 694.448 326.336H696.466V327.246H692.796V326.589Z"
            fill="#F6A200"
          />
          <path
            id="Vector_158"
            d="M697.256 326.727C697.256 326.382 697.524 326.122 697.86 326.122C698.204 326.122 698.472 326.382 698.472 326.727C698.472 327.055 698.204 327.322 697.86 327.322C697.516 327.322 697.256 327.055 697.256 326.727Z"
            fill="#F6A200"
          />
          <path
            id="Vector_159"
            d="M700.781 323.615L699.711 324.311L699.253 323.592L700.889 322.292H701.806V327.246H700.781V323.615Z"
            fill="#F6A200"
          />
          <path
            id="Vector_160"
            d="M702.971 325.801C702.971 325.267 703.246 324.8 703.774 324.578C703.437 324.357 703.269 323.997 703.269 323.554C703.269 322.797 703.873 322.216 704.874 322.216C705.868 322.216 706.472 322.797 706.472 323.554C706.472 323.997 706.304 324.357 705.968 324.578C706.495 324.8 706.771 325.267 706.771 325.801C706.771 326.703 706.052 327.33 704.874 327.33C703.69 327.33 702.971 326.703 702.971 325.801ZM705.693 325.71C705.693 325.305 705.409 324.968 704.874 324.968C704.331 324.968 704.049 325.305 704.049 325.71C704.049 326.114 704.347 326.428 704.874 326.428C705.402 326.428 705.693 326.114 705.693 325.71ZM705.531 323.676C705.531 323.348 705.295 323.072 704.874 323.072C704.447 323.072 704.217 323.348 704.217 323.676C704.217 323.997 704.431 324.288 704.874 324.288C705.31 324.288 705.531 323.997 705.531 323.676Z"
            fill="#F6A200"
          />
          <path
            id="Vector_161"
            d="M577.135 365.428C578.81 364.074 579.574 363.287 579.574 362.645C579.574 362.285 579.337 361.98 578.848 361.98C578.534 361.98 578.137 362.133 577.732 362.5L577.212 361.827C577.816 361.17 578.557 361.055 578.932 361.055C579.872 361.055 580.652 361.574 580.652 362.553C580.652 363.493 579.704 364.487 578.786 365.175H580.805V366.085H577.135V365.428Z"
            fill="#F6A200"
          />
          <path
            id="Vector_162"
            d="M581.595 365.566C581.595 365.221 581.863 364.961 582.198 364.961C582.543 364.961 582.811 365.221 582.811 365.566C582.811 365.894 582.543 366.161 582.198 366.161C581.855 366.161 581.595 365.894 581.595 365.566Z"
            fill="#F6A200"
          />
          <path
            id="Vector_163"
            d="M585.12 362.454L584.05 363.15L583.592 362.431L585.228 361.131H586.145V366.085H585.12V362.454Z"
            fill="#F6A200"
          />
          <path
            id="Vector_164"
            d="M587.332 364.404C587.332 363.929 587.508 363.447 587.807 363.05L589.313 361.025L590.123 361.574L589.259 362.714C589.305 362.706 589.366 362.698 589.405 362.698C590.375 362.698 591.086 363.44 591.086 364.35C591.086 365.374 590.375 366.161 589.205 366.161C588.036 366.161 587.332 365.404 587.332 364.404ZM590.016 364.396C590.016 363.937 589.695 363.563 589.205 363.563C588.709 363.563 588.403 363.937 588.403 364.396C588.403 364.885 588.694 365.26 589.205 365.26C589.71 365.26 590.016 364.885 590.016 364.396Z"
            fill="#F6A200"
          />
          <path
            id="Vector_165"
            d="M572.92 341.085C574.595 339.732 575.36 338.945 575.36 338.302C575.36 337.943 575.122 337.637 574.633 337.637C574.32 337.637 573.922 337.79 573.517 338.157L572.997 337.485C573.601 336.827 574.342 336.712 574.717 336.712C575.657 336.712 576.437 337.232 576.437 338.21C576.437 339.151 575.49 340.145 574.572 340.832H576.59V341.742H572.92V341.085Z"
            fill="#F6A200"
          />
          <path
            id="Vector_166"
            d="M577.38 341.223C577.38 340.878 577.648 340.618 577.984 340.618C578.328 340.618 578.596 340.878 578.596 341.223C578.596 341.551 578.328 341.819 577.984 341.819C577.64 341.819 577.38 341.551 577.38 341.223Z"
            fill="#F6A200"
          />
          <path
            id="Vector_167"
            d="M579.292 341.085C580.967 339.732 581.732 338.945 581.732 338.302C581.732 337.943 581.494 337.637 581.005 337.637C580.692 337.637 580.294 337.79 579.889 338.157L579.369 337.485C579.973 336.827 580.714 336.712 581.089 336.712C582.03 336.712 582.809 337.232 582.809 338.21C582.809 339.151 581.862 340.145 580.944 340.832H582.962V341.742H579.292V341.085Z"
            fill="#F6A200"
          />
          <path
            id="Vector_168"
            d="M583.73 341.237L584.166 340.534C584.487 340.825 584.938 340.932 585.343 340.932C585.986 340.932 586.421 340.611 586.421 340.107C586.421 339.717 586.062 339.396 585.443 339.396C585.191 339.396 584.984 339.434 584.74 339.571L584.395 338.967L585.894 337.698H583.983V336.788H587.208V337.668L586.031 338.699C586.169 338.707 586.299 338.738 586.429 338.777C587.04 338.952 587.484 339.442 587.484 340.145C587.484 341.269 586.551 341.819 585.435 341.819C584.716 341.819 584.12 341.597 583.73 341.237Z"
            fill="#F6A200"
          />
          <path
            id="Vector_169"
            d="M609.288 355.728C610.963 354.374 611.728 353.587 611.728 352.945C611.728 352.585 611.49 352.279 611.001 352.279C610.688 352.279 610.29 352.433 609.885 352.8L609.365 352.127C609.969 351.47 610.71 351.355 611.085 351.355C612.026 351.355 612.805 351.874 612.805 352.853C612.805 353.793 611.858 354.787 610.94 355.475H612.958V356.385H609.288V355.728Z"
            fill="#F6A200"
          />
          <path
            id="Vector_170"
            d="M613.748 355.865C613.748 355.521 614.016 355.261 614.352 355.261C614.697 355.261 614.964 355.521 614.964 355.865C614.964 356.194 614.697 356.461 614.352 356.461C614.008 356.461 613.748 356.194 613.748 355.865Z"
            fill="#F6A200"
          />
          <path
            id="Vector_171"
            d="M617.274 352.754L616.203 353.449L615.745 352.731L617.381 351.431H618.298V356.385H617.274V352.754Z"
            fill="#F6A200"
          />
          <path
            id="Vector_172"
            d="M623.24 353.113C623.24 353.587 623.064 354.069 622.766 354.466L621.26 356.492L620.449 355.942L621.313 354.803C621.267 354.81 621.206 354.818 621.168 354.818C620.197 354.818 619.486 354.076 619.486 353.166C619.486 352.142 620.197 351.355 621.366 351.355C622.536 351.355 623.24 352.112 623.24 353.113ZM620.556 353.12C620.556 353.579 620.877 353.954 621.366 353.954C621.864 353.954 622.169 353.579 622.169 353.12C622.169 352.631 621.879 352.257 621.366 352.257C620.862 352.257 620.556 352.631 620.556 353.12Z"
            fill="#F6A200"
          />
          <path
            id="Vector_173"
            d="M582.658 427.293C584.333 425.94 585.098 425.153 585.098 424.51C585.098 424.151 584.861 423.845 584.371 423.845C584.058 423.845 583.66 423.998 583.255 424.365L582.736 423.693C583.339 423.035 584.08 422.92 584.455 422.92C585.396 422.92 586.175 423.44 586.175 424.418C586.175 425.359 585.228 426.353 584.31 427.04H586.328V427.95H582.658V427.293Z"
            fill="#F6A200"
          />
          <path
            id="Vector_174"
            d="M587.118 427.431C587.118 427.086 587.386 426.826 587.722 426.826C588.067 426.826 588.334 427.086 588.334 427.431C588.334 427.759 588.067 428.027 587.722 428.027C587.378 428.027 587.118 427.759 587.118 427.431Z"
            fill="#F6A200"
          />
          <path
            id="Vector_175"
            d="M590.644 424.32L589.573 425.015L589.115 424.296L590.751 422.996H591.668V427.95H590.644V424.32Z"
            fill="#F6A200"
          />
          <path
            id="Vector_176"
            d="M592.948 427.523L593.338 426.766C593.606 426.98 594.087 427.148 594.507 427.148C595.196 427.148 595.517 426.766 595.517 426.353C595.517 425.825 595.034 425.566 594.423 425.566C594.072 425.566 593.728 425.695 593.514 425.818L593.139 425.474V422.996H596.296V423.906H594.163V424.816C594.339 424.763 594.538 424.732 594.744 424.732C595.731 424.732 596.579 425.267 596.579 426.299C596.579 427.362 595.753 428.027 594.538 428.027C593.858 428.027 593.323 427.82 592.948 427.523Z"
            fill="#F6A200"
          />
          <path
            id="Vector_177"
            d="M634.296 443.878C635.971 442.525 636.736 441.737 636.736 441.095C636.736 440.736 636.498 440.43 636.009 440.43C635.696 440.43 635.298 440.583 634.893 440.95L634.373 440.278C634.977 439.62 635.718 439.505 636.093 439.505C637.033 439.505 637.813 440.025 637.813 441.003C637.813 441.944 636.865 442.938 635.948 443.625H637.966V444.535H634.296V443.878Z"
            fill="#F6A200"
          />
          <path
            id="Vector_178"
            d="M638.756 444.016C638.756 443.671 639.024 443.411 639.36 443.411C639.704 443.411 639.972 443.671 639.972 444.016C639.972 444.344 639.704 444.612 639.36 444.612C639.016 444.612 638.756 444.344 638.756 444.016Z"
            fill="#F6A200"
          />
          <path
            id="Vector_179"
            d="M642.281 440.904L641.211 441.6L640.753 440.881L642.389 439.581H643.306V444.535H642.281V440.904Z"
            fill="#F6A200"
          />
          <path
            id="Vector_180"
            d="M644.585 444.108L644.976 443.351C645.243 443.565 645.725 443.733 646.145 443.733C646.833 443.733 647.155 443.351 647.155 442.938C647.155 442.41 646.672 442.151 646.061 442.151C645.709 442.151 645.365 442.28 645.152 442.403L644.777 442.059V439.581H647.934V440.491H645.801V441.401C645.977 441.348 646.176 441.317 646.382 441.317C647.368 441.317 648.217 441.852 648.217 442.884C648.217 443.946 647.391 444.612 646.176 444.612C645.495 444.612 644.96 444.405 644.585 444.108Z"
            fill="#F6A200"
          />
          <path
            id="Vector_181"
            d="M53.467 158.363L55.3108 155.387C56.6697 156.616 58.5784 157.07 60.2927 157.07C63.01 157.07 64.8538 155.711 64.8538 153.575C64.8538 151.926 63.3333 150.567 60.7131 150.567C59.6458 150.567 58.7722 150.729 57.7371 151.311L56.2815 148.756L62.6218 143.386H54.5344V139.536H68.1858V143.257L63.2039 147.623C63.7864 147.656 64.3362 147.785 64.886 147.947C67.4739 148.691 69.3503 150.761 69.3503 153.737C69.3503 158.492 65.4036 160.821 60.6809 160.821C57.6399 160.821 55.1169 159.883 53.467 158.363Z"
            fill="#D51317"
          />
          <path id="Vector_182" d="M74.9539 152.011H76.8445V159.141H81.9084V160.762H74.9539V152.011Z" fill="#D51317" />
          <path
            id="Vector_183"
            d="M82.8376 152.119C82.8376 151.525 83.324 151.039 83.9045 151.039C84.4988 151.039 84.9846 151.525 84.9846 152.119C84.9846 152.7 84.4988 153.186 83.9045 153.186C83.324 153.186 82.8376 152.7 82.8376 152.119ZM83.0129 154.01H84.8225V160.762H83.0129V154.01Z"
            fill="#D51317"
          />
          <path
            id="Vector_184"
            d="M86.199 154.01H87.968V154.915C88.5085 154.172 89.2781 153.875 90.1018 153.875C91.8845 153.875 92.5056 155.023 92.5056 156.873V160.762H90.6961V157.102C90.6961 156.116 90.4397 155.59 89.5212 155.59C88.6165 155.59 88.0086 156.319 88.0086 157.345V160.762H86.199L86.199 154.01Z"
            fill="#D51317"
          />
          <path
            id="Vector_185"
            d="M93.5837 157.386C93.5837 155.441 94.7991 153.875 96.6624 153.875C97.4456 153.875 98.2156 154.185 98.7014 154.766V151.876H100.511V160.762H98.7961V159.952C98.3098 160.6 97.4456 160.897 96.6355 160.897C94.7717 160.897 93.5837 159.33 93.5837 157.386ZM98.7014 157.386C98.7014 156.333 98.0266 155.549 97.0945 155.549C96.1223 155.549 95.4202 156.333 95.4202 157.386C95.4202 158.453 96.1223 159.222 97.0945 159.222C98.0266 159.222 98.7014 158.466 98.7014 157.386Z"
            fill="#D51317"
          />
          <path
            id="Vector_186"
            d="M101.683 157.386C101.683 155.441 102.871 153.875 104.735 153.875C105.518 153.875 106.356 154.185 106.842 154.834V154.01H108.611V160.762H106.842V159.952C106.369 160.6 105.518 160.897 104.735 160.897C102.871 160.897 101.683 159.33 101.683 157.386ZM106.801 157.386C106.801 156.333 106.126 155.549 105.194 155.549C104.222 155.549 103.52 156.333 103.52 157.386C103.52 158.453 104.222 159.222 105.194 159.222C106.126 159.222 106.801 158.466 106.801 157.386Z"
            fill="#D51317"
          />
          <path
            id="Vector_187"
            d="M109.986 151.876H111.795V154.861C112.322 154.158 113.065 153.875 113.875 153.875C115.631 153.875 116.279 154.982 116.279 156.873V160.762H114.469V157.102C114.469 156.116 114.172 155.59 113.281 155.59C112.322 155.59 111.795 156.36 111.795 157.332V160.762H109.986L109.986 151.876Z"
            fill="#D51317"
          />
          <path
            id="Vector_188"
            d="M117.37 157.386C117.37 155.428 118.964 153.875 120.976 153.875C123.001 153.875 124.595 155.428 124.595 157.386C124.595 159.344 123.001 160.897 120.976 160.897C118.964 160.897 117.37 159.344 117.37 157.386ZM122.745 157.386C122.745 156.333 121.989 155.549 120.976 155.549C119.963 155.549 119.207 156.333 119.207 157.386C119.207 158.453 119.963 159.222 120.976 159.222C121.989 159.222 122.745 158.453 122.745 157.386Z"
            fill="#D51317"
          />
          <path
            id="Vector_189"
            d="M126.051 155.482H124.997V154.024H126.051V153.578C126.051 152.011 126.915 151.336 128.063 151.336C128.671 151.336 129.345 151.511 129.818 151.755L129.305 153.091C129.157 153.024 128.86 152.889 128.549 152.889C128.171 152.889 127.86 153.078 127.86 153.78V154.024H129.548V155.482H127.86V160.762H126.051V155.482Z"
            fill="#D51317"
          />
          <path
            id="Vector_190"
            d="M63.533 284.392H70.3796V286.013H65.4236V287.795H70.1228V289.403H65.4236V291.523H70.5686V293.143H63.533V284.392Z"
            fill="#D51317"
          />
          <path id="Vector_191" d="M71.741 284.392H73.6316V293.143H71.741V284.392Z" fill="#D51317" />
          <path
            id="Vector_192"
            d="M75.3723 284.392H77.1819L80.1931 288.551C80.6794 289.213 81.2332 290.158 81.2332 290.158V284.392H83.1238V293.143H81.3005L78.3835 289.146C77.803 288.362 77.2629 287.431 77.2629 287.431V293.143H75.3723V284.392Z"
            fill="#D51317"
          />
          <path
            id="Vector_193"
            d="M84.5388 288.768C84.5388 286.269 86.4563 284.257 89.157 284.257C90.386 284.257 91.4666 284.69 92.2629 285.378L91.0881 286.661C90.4807 286.12 89.8591 285.972 89.1975 285.972C87.6716 285.972 86.5105 287.214 86.5105 288.768C86.5105 290.334 87.6448 291.576 89.1975 291.576C90.0349 291.576 90.7371 291.198 91.2097 290.698V289.415H89.7244V288.038H92.9382V291.442C92.1687 292.589 90.7507 293.291 89.1707 293.291C86.47 293.291 84.5388 291.279 84.5388 288.768Z"
            fill="#D51317"
          />
          <path
            id="Vector_194"
            d="M97.7024 284.392H99.5657L103.374 293.143H101.456L100.862 291.752H96.4192L95.825 293.143H93.8943L97.7024 284.392ZM100.268 290.279L99.2551 287.781C98.9851 287.12 98.6477 286.242 98.634 286.215C98.6204 286.242 98.283 287.12 98.0129 287.781L97.0002 290.279H100.268Z"
            fill="#D51317"
          />
          <path
            id="Vector_195"
            d="M104.37 284.392H106.179L109.191 288.551C109.677 289.213 110.231 290.158 110.231 290.158V284.392H112.121V293.143H110.298L107.381 289.146C106.801 288.362 106.26 287.431 106.26 287.431V293.143H104.37V284.392Z"
            fill="#D51317"
          />
          <path
            id="Vector_196"
            d="M113.536 288.768C113.536 286.269 115.454 284.257 118.155 284.257C119.384 284.257 120.464 284.69 121.26 285.378L120.086 286.661C119.478 286.12 118.857 285.972 118.195 285.972C116.669 285.972 115.508 287.214 115.508 288.768C115.508 290.334 116.642 291.576 118.195 291.576C119.032 291.576 119.735 291.198 120.207 290.698V289.415H118.722V288.038H121.936V291.442C121.166 292.589 119.748 293.291 118.168 293.291C115.468 293.291 113.536 291.279 113.536 288.768Z"
            fill="#D51317"
          />
          <path
            id="Vector_197"
            d="M120.489 228.505L120.924 227.801C121.245 228.091 121.697 228.198 122.101 228.198C122.743 228.198 123.179 227.878 123.179 227.373C123.179 226.983 122.82 226.662 122.201 226.662C121.948 226.662 121.742 226.7 121.497 226.838L121.154 226.234L122.652 224.965H120.741V224.055H123.967V224.934L122.789 225.966C122.927 225.974 123.057 226.005 123.187 226.043C123.799 226.218 124.242 226.708 124.242 227.411C124.242 228.535 123.309 229.086 122.193 229.086C121.475 229.086 120.878 228.864 120.489 228.505Z"
            fill="#D51317"
          />
          <path
            id="Vector_198"
            d="M124.948 228.489C124.948 228.145 125.216 227.885 125.552 227.885C125.896 227.885 126.164 228.145 126.164 228.489C126.164 228.818 125.896 229.086 125.552 229.086C125.208 229.086 124.948 228.818 124.948 228.489Z"
            fill="#D51317"
          />
          <path
            id="Vector_199"
            d="M126.83 226.532C126.83 225.034 127.64 223.979 128.81 223.979C129.972 223.979 130.782 225.034 130.782 226.532C130.782 228.03 129.972 229.086 128.81 229.086C127.64 229.086 126.83 228.03 126.83 226.532ZM129.712 226.532C129.712 225.569 129.406 224.896 128.81 224.896C128.206 224.896 127.892 225.569 127.892 226.532C127.892 227.495 128.206 228.168 128.81 228.168C129.406 228.168 129.712 227.495 129.712 226.532Z"
            fill="#D51317"
          />
          <path
            id="Vector_200"
            d="M133.798 228.053H131.466V227.358L133.323 223.903L134.18 224.33L132.666 227.144H133.798V226.066H134.784V227.144H135.372V228.053H134.784V229.009H133.798V228.053Z"
            fill="#D51317"
          />
          <path
            id="Vector_201"
            d="M56.1902 228.505L56.6257 227.801C56.947 228.091 57.3982 228.198 57.803 228.198C58.4451 228.198 58.8811 227.878 58.8811 227.373C58.8811 226.983 58.5217 226.662 57.9026 226.662C57.6501 226.662 57.4436 226.7 57.1995 226.838L56.8552 226.234L58.3538 224.965H56.4426V224.055H59.6682V224.934L58.491 225.966C58.6287 225.974 58.7585 226.005 58.8889 226.043C59.5002 226.218 59.9436 226.708 59.9436 227.411C59.9436 228.535 59.011 229.086 57.8948 229.086C57.1765 229.086 56.5798 228.864 56.1902 228.505Z"
            fill="#D51317"
          />
          <path
            id="Vector_202"
            d="M60.6501 228.489C60.6501 228.145 60.9177 227.885 61.2542 227.885C61.5979 227.885 61.8655 228.145 61.8655 228.489C61.8655 228.818 61.5979 229.086 61.2542 229.086C60.9099 229.086 60.6501 228.818 60.6501 228.489Z"
            fill="#D51317"
          />
          <path
            id="Vector_203"
            d="M62.5315 226.532C62.5315 225.034 63.342 223.979 64.5115 223.979C65.6736 223.979 66.4841 225.034 66.4841 226.532C66.4841 228.03 65.6736 229.086 64.5115 229.086C63.342 229.086 62.5315 228.03 62.5315 226.532ZM65.4138 226.532C65.4138 225.569 65.1077 224.896 64.5115 224.896C63.9075 224.896 63.594 225.569 63.594 226.532C63.594 227.495 63.9075 228.168 64.5115 228.168C65.1077 228.168 65.4138 227.495 65.4138 226.532Z"
            fill="#D51317"
          />
          <path
            id="Vector_204"
            d="M67.1218 228.505L67.5574 227.801C67.8787 228.091 68.3298 228.198 68.7346 228.198C69.3767 228.198 69.8127 227.878 69.8127 227.373C69.8127 226.983 69.4534 226.662 68.8342 226.662C68.5818 226.662 68.3752 226.7 68.1311 226.838L67.7869 226.234L69.2854 224.965H67.3743V224.055H70.5999V224.934L69.4226 225.966C69.5603 225.974 69.6902 226.005 69.8206 226.043C70.4319 226.218 70.8752 226.708 70.8752 227.411C70.8752 228.535 69.9426 229.086 68.8264 229.086C68.1082 229.086 67.5115 228.864 67.1218 228.505Z"
            fill="#D51317"
          />
          <path
            id="Vector_205"
            d="M120.611 382.682L121.047 381.979C121.368 382.27 121.819 382.376 122.224 382.376C122.866 382.376 123.302 382.055 123.302 381.551C123.302 381.161 122.943 380.84 122.323 380.84C122.071 380.84 121.865 380.878 121.62 381.016L121.276 380.411L122.775 379.143H120.864V378.233H124.089V379.112L122.912 380.144C123.05 380.152 123.179 380.183 123.31 380.221C123.921 380.397 124.365 380.886 124.365 381.589C124.365 382.713 123.432 383.263 122.316 383.263C121.597 383.263 121.001 383.041 120.611 382.682Z"
            fill="#D51317"
          />
          <path
            id="Vector_206"
            d="M125.071 382.667C125.071 382.322 125.339 382.063 125.675 382.063C126.019 382.063 126.286 382.322 126.286 382.667C126.286 382.995 126.019 383.263 125.675 383.263C125.331 383.263 125.071 382.995 125.071 382.667Z"
            fill="#D51317"
          />
          <path
            id="Vector_207"
            d="M126.952 380.71C126.952 379.211 127.763 378.156 128.932 378.156C130.094 378.156 130.905 379.211 130.905 380.71C130.905 382.208 130.094 383.263 128.932 383.263C127.763 383.263 126.952 382.208 126.952 380.71ZM129.835 380.71C129.835 379.746 129.529 379.073 128.932 379.073C128.328 379.073 128.015 379.746 128.015 380.71C128.015 381.673 128.328 382.346 128.932 382.346C129.529 382.346 129.835 381.673 129.835 380.71Z"
            fill="#D51317"
          />
          <path
            id="Vector_208"
            d="M131.543 382.529C133.217 381.176 133.981 380.389 133.981 379.746C133.981 379.387 133.744 379.081 133.255 379.081C132.942 379.081 132.544 379.235 132.139 379.602L131.619 378.929C132.223 378.272 132.965 378.156 133.339 378.156C134.28 378.156 135.059 378.676 135.059 379.654C135.059 380.595 134.111 381.589 133.194 382.277H135.212V383.187H131.543V382.529Z"
            fill="#D51317"
          />
          <path
            id="Vector_209"
            d="M56.9397 382.682L57.3752 381.979C57.6965 382.27 58.1477 382.376 58.5525 382.376C59.1946 382.376 59.6306 382.055 59.6306 381.551C59.6306 381.161 59.2712 380.84 58.6521 380.84C58.3997 380.84 58.1936 380.878 57.9485 381.016L57.6047 380.411L59.1033 379.143H57.1921V378.233H60.4177V379.112L59.2405 380.144C59.3782 380.152 59.5081 380.183 59.6384 380.221C60.2498 380.397 60.6931 380.886 60.6931 381.589C60.6931 382.713 59.7605 383.263 58.6443 383.263C57.926 383.263 57.3293 383.041 56.9397 382.682Z"
            fill="#D51317"
          />
          <path
            id="Vector_210"
            d="M61.3997 382.667C61.3997 382.322 61.6672 382.063 62.0037 382.063C62.3474 382.063 62.615 382.322 62.615 382.667C62.615 382.995 62.3474 383.263 62.0037 383.263C61.6594 383.263 61.3997 382.995 61.3997 382.667Z"
            fill="#D51317"
          />
          <path
            id="Vector_211"
            d="M63.281 380.71C63.281 379.211 64.0915 378.156 65.261 378.156C66.4231 378.156 67.2336 379.211 67.2336 380.71C67.2336 382.208 66.4231 383.263 65.261 383.263C64.0915 383.263 63.281 382.208 63.281 380.71ZM66.1633 380.71C66.1633 379.746 65.8572 379.073 65.261 379.073C64.657 379.073 64.3435 379.746 64.3435 380.71C64.3435 381.673 64.657 382.346 65.261 382.346C65.8572 382.346 66.1633 381.673 66.1633 380.71Z"
            fill="#D51317"
          />
          <path
            id="Vector_212"
            d="M69.4841 379.556L68.4138 380.251L67.9553 379.532L69.5915 378.233H70.5085V383.187H69.4841V379.556Z"
            fill="#D51317"
          />
          <path
            id="Vector_213"
            d="M270.099 193.499H276.649V195.119H271.99V196.902H275.959V198.509H271.99V202.25H270.099V193.499Z"
            fill="#86B361"
          />
          <path
            id="Vector_214"
            d="M277.281 198.874C277.281 196.916 278.874 195.362 280.886 195.362C282.911 195.362 284.505 196.916 284.505 198.874C284.505 200.832 282.911 202.385 280.886 202.385C278.874 202.385 277.281 200.832 277.281 198.874ZM282.655 198.874C282.655 197.82 281.899 197.037 280.886 197.037C279.873 197.037 279.116 197.82 279.116 198.874C279.116 199.941 279.873 200.71 280.886 200.71C281.899 200.71 282.655 199.941 282.655 198.874Z"
            fill="#86B361"
          />
          <path
            id="Vector_215"
            d="M286.365 202.587C287.203 202.587 287.514 202.304 287.757 201.777L287.906 201.48L285.083 195.498H286.919L288.283 198.657C288.486 199.13 288.729 199.805 288.729 199.805C288.729 199.805 289.013 199.009 289.161 198.617L290.39 195.498H292.199L289.201 202.439C288.473 204.1 287.203 204.235 286.365 204.235V202.587Z"
            fill="#86B361"
          />
          <path
            id="Vector_216"
            d="M292.779 198.874C292.779 196.929 294.291 195.362 296.276 195.362C298.113 195.362 299.558 196.929 299.558 198.847C299.558 199.171 299.517 199.495 299.517 199.495H294.615C294.831 200.426 295.601 200.872 296.492 200.872C297.14 200.872 297.816 200.683 298.315 200.345L298.99 201.642C298.234 202.142 297.357 202.385 296.479 202.385C294.507 202.385 292.779 201.102 292.779 198.874ZM297.856 198.293C297.721 197.442 297.045 196.875 296.222 196.875C295.439 196.875 294.764 197.442 294.588 198.293H297.856Z"
            fill="#86B361"
          />
          <path
            id="Vector_217"
            d="M300.743 195.498H302.527V196.794C302.715 196.24 303.404 195.362 304.889 195.362V197.334C303.323 197.334 302.553 198.05 302.553 199.657V202.25H300.743V195.498Z"
            fill="#86B361"
          />
          <path
            id="Vector_218"
            d="M259.084 186.884L254.555 189.828L252.615 186.787L259.537 181.288H263.419V202.25H259.084V186.884Z"
            fill="#86B361"
          />
          <path
            id="Vector_219"
            d="M692.665 396.917C694.34 395.564 695.105 394.777 695.105 394.134C695.105 393.775 694.867 393.469 694.378 393.469C694.065 393.469 693.667 393.622 693.262 393.989L692.742 393.317C693.346 392.659 694.087 392.544 694.462 392.544C695.403 392.544 696.182 393.064 696.182 394.042C696.182 394.983 695.235 395.977 694.317 396.664H696.335V397.574H692.665V396.917Z"
            fill="#F6A200"
          />
          <path
            id="Vector_220"
            d="M697.125 397.055C697.125 396.71 697.393 396.45 697.729 396.45C698.073 396.45 698.341 396.71 698.341 397.055C698.341 397.383 698.073 397.651 697.729 397.651C697.385 397.651 697.125 397.383 697.125 397.055Z"
            fill="#F6A200"
          />
          <path
            id="Vector_221"
            d="M700.651 393.944L699.58 394.639L699.122 393.92L700.758 392.62H701.675V397.574H700.651V393.944Z"
            fill="#F6A200"
          />
          <path
            id="Vector_222"
            d="M705.386 393.53H702.779V392.62H706.571V393.263L704.476 397.574H703.36L705.386 393.53Z"
            fill="#F6A200"
          />
          <path
            id="Vector_223"
            d="M389.236 329.367C390.91 328.014 391.675 327.227 391.675 326.584C391.675 326.225 391.438 325.919 390.948 325.919C390.635 325.919 390.238 326.072 389.832 326.44L389.313 325.767C389.916 325.11 390.657 324.994 391.032 324.994C391.973 324.994 392.752 325.514 392.752 326.492C392.752 327.433 391.805 328.427 390.887 329.114H392.906V330.025H389.236V329.367Z"
            fill="#F6A200"
          />
          <path
            id="Vector_224"
            d="M393.696 329.505C393.696 329.16 393.963 328.901 394.299 328.901C394.644 328.901 394.911 329.16 394.911 329.505C394.911 329.833 394.644 330.101 394.299 330.101C393.955 330.101 393.696 329.833 393.696 329.505Z"
            fill="#F6A200"
          />
          <path
            id="Vector_225"
            d="M395.577 327.548C395.577 326.049 396.388 324.994 397.558 324.994C398.719 324.994 399.53 326.049 399.53 327.548C399.53 329.046 398.719 330.101 397.558 330.101C396.388 330.101 395.577 329.046 395.577 327.548ZM398.459 327.548C398.459 326.584 398.154 325.911 397.558 325.911C396.953 325.911 396.64 326.584 396.64 327.548C396.64 328.511 396.953 329.184 397.558 329.184C398.154 329.184 398.459 328.511 398.459 327.548Z"
            fill="#F6A200"
          />
          <path
            id="Vector_226"
            d="M402.545 329.069H400.213V328.373L402.072 324.918L402.927 325.346L401.413 328.159H402.545V327.081H403.531V328.159H404.12V329.069H403.531V330.025H402.545V329.069Z"
            fill="#F6A200"
          />
          <path
            id="Vector_227"
            d="M433.484 319.308C435.158 317.954 435.923 317.167 435.923 316.525C435.923 316.165 435.686 315.86 435.197 315.86C434.883 315.86 434.486 316.013 434.08 316.38L433.561 315.707C434.164 315.05 434.906 314.935 435.281 314.935C436.221 314.935 437 315.454 437 316.433C437 317.373 436.053 318.367 435.135 319.055H437.154V319.965H433.484V319.308Z"
            fill="#F6A200"
          />
          <path
            id="Vector_228"
            d="M437.944 319.445C437.944 319.101 438.211 318.841 438.547 318.841C438.892 318.841 439.159 319.101 439.159 319.445C439.159 319.774 438.892 320.041 438.547 320.041C438.203 320.041 437.944 319.774 437.944 319.445Z"
            fill="#F6A200"
          />
          <path
            id="Vector_229"
            d="M439.856 319.308C441.531 317.954 442.295 317.167 442.295 316.525C442.295 316.165 442.058 315.86 441.569 315.86C441.255 315.86 440.858 316.013 440.452 316.38L439.933 315.707C440.536 315.05 441.278 314.935 441.653 314.935C442.593 314.935 443.372 315.454 443.372 316.433C443.372 317.373 442.425 318.367 441.507 319.055H443.526V319.965H439.856V319.308Z"
            fill="#F6A200"
          />
          <path
            id="Vector_230"
            d="M446.817 315.921H444.209V315.011H448.001V315.654L445.906 319.965H444.79L446.817 315.921Z"
            fill="#F6A200"
          />
          <path
            id="Vector_231"
            d="M375.879 389.007C377.554 387.654 378.319 386.866 378.319 386.224C378.319 385.864 378.081 385.559 377.592 385.559C377.279 385.559 376.881 385.712 376.476 386.079L375.956 385.406C376.56 384.749 377.301 384.634 377.676 384.634C378.616 384.634 379.396 385.154 379.396 386.132C379.396 387.072 378.448 388.067 377.531 388.754H379.549V389.664H375.879V389.007Z"
            fill="#F6A200"
          />
          <path
            id="Vector_232"
            d="M380.339 389.145C380.339 388.8 380.607 388.54 380.943 388.54C381.287 388.54 381.555 388.8 381.555 389.145C381.555 389.473 381.287 389.74 380.943 389.74C380.599 389.74 380.339 389.473 380.339 389.145Z"
            fill="#F6A200"
          />
          <path
            id="Vector_233"
            d="M382.221 387.188C382.221 385.689 383.031 384.634 384.201 384.634C385.363 384.634 386.173 385.689 386.173 387.188C386.173 388.686 385.363 389.74 384.201 389.74C383.031 389.74 382.221 388.686 382.221 387.188ZM385.103 387.188C385.103 386.224 384.797 385.551 384.201 385.551C383.597 385.551 383.283 386.224 383.283 387.188C383.283 388.151 383.597 388.823 384.201 388.823C384.797 388.823 385.103 388.151 385.103 387.188Z"
            fill="#F6A200"
          />
          <path
            id="Vector_234"
            d="M386.903 389.237L387.293 388.48C387.561 388.694 388.042 388.862 388.462 388.862C389.151 388.862 389.472 388.48 389.472 388.067C389.472 387.539 388.99 387.279 388.378 387.279C388.027 387.279 387.683 387.409 387.469 387.531L387.094 387.188V384.71H390.251V385.62H388.118V386.529C388.294 386.477 388.493 386.445 388.699 386.445C389.686 386.445 390.534 386.981 390.534 388.013C390.534 389.075 389.708 389.74 388.493 389.74C387.813 389.74 387.278 389.534 386.903 389.237Z"
            fill="#F6A200"
          />
          <path
            id="Vector_235"
            d="M411.711 397.942C413.386 396.588 414.151 395.801 414.151 395.158C414.151 394.799 413.913 394.493 413.424 394.493C413.111 394.493 412.713 394.647 412.308 395.014L411.788 394.341C412.392 393.684 413.133 393.569 413.508 393.569C414.448 393.569 415.228 394.088 415.228 395.067C415.228 396.007 414.281 397.001 413.363 397.689H415.381V398.599H411.711V397.942Z"
            fill="#F6A200"
          />
          <path
            id="Vector_236"
            d="M416.171 398.079C416.171 397.735 416.439 397.475 416.775 397.475C417.119 397.475 417.387 397.735 417.387 398.079C417.387 398.407 417.119 398.675 416.775 398.675C416.431 398.675 416.171 398.407 416.171 398.079Z"
            fill="#F6A200"
          />
          <path
            id="Vector_237"
            d="M418.053 396.122C418.053 394.623 418.864 393.569 420.033 393.569C421.195 393.569 422.005 394.623 422.005 396.122C422.005 397.62 421.195 398.675 420.033 398.675C418.864 398.675 418.053 397.62 418.053 396.122ZM420.935 396.122C420.935 395.158 420.629 394.486 420.033 394.486C419.429 394.486 419.115 395.158 419.115 396.122C419.115 397.085 419.429 397.758 420.033 397.758C420.629 397.758 420.935 397.085 420.935 396.122Z"
            fill="#F6A200"
          />
          <path
            id="Vector_238"
            d="M426.397 395.327C426.397 395.801 426.221 396.282 425.923 396.68L424.417 398.706L423.607 398.155L424.47 397.017C424.424 397.024 424.364 397.031 424.325 397.031C423.354 397.031 422.643 396.29 422.643 395.38C422.643 394.356 423.354 393.569 424.524 393.569C425.694 393.569 426.397 394.325 426.397 395.327ZM423.713 395.334C423.713 395.793 424.034 396.168 424.524 396.168C425.021 396.168 425.326 395.793 425.326 395.334C425.326 394.845 425.036 394.471 424.524 394.471C424.02 394.471 423.713 394.845 423.713 395.334Z"
            fill="#F6A200"
          />
          <path
            id="BOOTH_2.11"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.11' in exhibitorLocations}
            data-booth="2.11"
            opacity="0.4"
            d="M478.474 379.75H439.852V414.473H478.474V379.75Z"
            fill="#F9B119"
          />
          <path
            id="Vector_239"
            d="M478.474 379.75H439.852V414.473H478.474V379.75Z"
            stroke="#F9B119"
            strokeWidth="0.989"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_240"
            d="M452.488 397.935C454.162 396.581 454.927 395.794 454.927 395.152C454.927 394.792 454.69 394.487 454.2 394.487C453.887 394.487 453.49 394.64 453.084 395.007L452.565 394.334C453.168 393.677 453.909 393.562 454.284 393.562C455.225 393.562 456.004 394.081 456.004 395.06C456.004 396 455.057 396.994 454.139 397.682H456.157V398.592H452.488V397.935Z"
            fill="#F6A200"
          />
          <path
            id="Vector_241"
            d="M456.948 398.072C456.948 397.728 457.215 397.468 457.551 397.468C457.896 397.468 458.163 397.728 458.163 398.072C458.163 398.401 457.896 398.668 457.551 398.668C457.207 398.668 456.948 398.401 456.948 398.072Z"
            fill="#F6A200"
          />
          <path
            id="Vector_242"
            d="M460.473 394.961L459.403 395.656L458.945 394.938L460.58 393.638H461.497V398.592H460.473V394.961Z"
            fill="#F6A200"
          />
          <path
            id="Vector_243"
            d="M464.298 394.961L463.228 395.656L462.77 394.938L464.406 393.638H465.323V398.592H464.298V394.961Z"
            fill="#F6A200"
          />
          <path
            id="Vector_244"
            d="M458.432 349.135C460.107 347.781 460.871 346.994 460.871 346.352C460.871 345.992 460.634 345.687 460.145 345.687C459.831 345.687 459.434 345.84 459.029 346.207L458.509 345.534C459.113 344.877 459.854 344.762 460.229 344.762C461.169 344.762 461.948 345.281 461.948 346.26C461.948 347.2 461.001 348.195 460.083 348.882H462.102V349.792H458.432V349.135Z"
            fill="#F6A200"
          />
          <path
            id="Vector_245"
            d="M462.892 349.273C462.892 348.928 463.159 348.668 463.495 348.668C463.84 348.668 464.108 348.928 464.108 349.273C464.108 349.601 463.84 349.868 463.495 349.868C463.152 349.868 462.892 349.601 462.892 349.273Z"
            fill="#F6A200"
          />
          <path
            id="Vector_246"
            d="M464.804 349.135C466.479 347.781 467.243 346.994 467.243 346.352C467.243 345.992 467.006 345.687 466.517 345.687C466.203 345.687 465.806 345.84 465.401 346.207L464.881 345.534C465.485 344.877 466.226 344.762 466.601 344.762C467.541 344.762 468.321 345.281 468.321 346.26C468.321 347.2 467.373 348.195 466.455 348.882H468.474V349.792H464.804V349.135Z"
            fill="#F6A200"
          />
          <path
            id="Vector_247"
            d="M469.241 348.111C469.241 347.636 469.417 347.154 469.716 346.757L471.222 344.732L472.032 345.281L471.168 346.421C471.214 346.413 471.276 346.405 471.314 346.405C472.284 346.405 472.995 347.147 472.995 348.057C472.995 349.081 472.284 349.868 471.115 349.868C469.946 349.868 469.241 349.112 469.241 348.111ZM471.925 348.103C471.925 347.644 471.604 347.27 471.115 347.27C470.617 347.27 470.312 347.644 470.312 348.103C470.312 348.592 470.603 348.967 471.115 348.967C471.619 348.967 471.925 348.592 471.925 348.103Z"
            fill="#F6A200"
          />
          <path
            id="Vector_248"
            d="M484.044 349.135C485.719 347.781 486.484 346.994 486.484 346.352C486.484 345.992 486.246 345.687 485.757 345.687C485.444 345.687 485.046 345.84 484.641 346.207L484.121 345.534C484.725 344.877 485.466 344.762 485.841 344.762C486.781 344.762 487.561 345.281 487.561 346.26C487.561 347.2 486.614 348.195 485.696 348.882H487.714V349.792H484.044V349.135Z"
            fill="#F6A200"
          />
          <path
            id="Vector_249"
            d="M488.504 349.273C488.504 348.928 488.772 348.668 489.108 348.668C489.452 348.668 489.72 348.928 489.72 349.273C489.72 349.601 489.452 349.868 489.108 349.868C488.764 349.868 488.504 349.601 488.504 349.273Z"
            fill="#F6A200"
          />
          <path
            id="Vector_250"
            d="M490.416 349.135C492.091 347.781 492.856 346.994 492.856 346.352C492.856 345.992 492.618 345.687 492.129 345.687C491.816 345.687 491.418 345.84 491.013 346.207L490.493 345.534C491.097 344.877 491.838 344.762 492.213 344.762C493.154 344.762 493.933 345.281 493.933 346.26C493.933 347.2 492.986 348.195 492.068 348.882H494.086V349.792H490.416V349.135Z"
            fill="#F6A200"
          />
          <path
            id="Vector_251"
            d="M494.946 349.364L495.336 348.608C495.604 348.821 496.085 348.989 496.505 348.989C497.194 348.989 497.515 348.608 497.515 348.195C497.515 347.667 497.032 347.407 496.421 347.407C496.07 347.407 495.726 347.537 495.512 347.659L495.137 347.316V344.838H498.294V345.748H496.161V346.657C496.337 346.605 496.536 346.573 496.742 346.573C497.729 346.573 498.577 347.109 498.577 348.141C498.577 349.203 497.751 349.868 496.536 349.868C495.856 349.868 495.321 349.662 494.946 349.364Z"
            fill="#F6A200"
          />
          <path
            id="Vector_252"
            d="M530.67 349.135C532.345 347.781 533.11 346.994 533.11 346.352C533.11 345.992 532.872 345.687 532.383 345.687C532.07 345.687 531.672 345.84 531.267 346.207L530.747 345.534C531.351 344.877 532.092 344.762 532.467 344.762C533.407 344.762 534.187 345.281 534.187 346.26C534.187 347.2 533.24 348.195 532.322 348.882H534.34V349.792H530.67V349.135Z"
            fill="#F6A200"
          />
          <path
            id="Vector_253"
            d="M535.13 349.273C535.13 348.928 535.398 348.668 535.734 348.668C536.078 348.668 536.346 348.928 536.346 349.273C536.346 349.601 536.078 349.868 535.734 349.868C535.39 349.868 535.13 349.601 535.13 349.273Z"
            fill="#F6A200"
          />
          <path
            id="Vector_254"
            d="M537.042 349.135C538.717 347.781 539.482 346.994 539.482 346.352C539.482 345.992 539.244 345.687 538.755 345.687C538.442 345.687 538.044 345.84 537.639 346.207L537.119 345.534C537.723 344.877 538.464 344.762 538.839 344.762C539.78 344.762 540.559 345.281 540.559 346.26C540.559 347.2 539.612 348.195 538.694 348.882H540.712V349.792H537.042V349.135Z"
            fill="#F6A200"
          />
          <path
            id="Vector_255"
            d="M543.858 348.836H541.526V348.141L543.384 344.686L544.24 345.113L542.726 347.927H543.858V346.849H544.844V347.927H545.433V348.836H544.844V349.792H543.858V348.836Z"
            fill="#F6A200"
          />
          <path
            id="Vector_256"
            d="M510.942 388.999C512.616 387.646 513.381 386.859 513.381 386.216C513.381 385.857 513.144 385.551 512.655 385.551C512.341 385.551 511.944 385.704 511.538 386.071L511.019 385.399C511.622 384.741 512.364 384.626 512.739 384.626C513.679 384.626 514.458 385.146 514.458 386.124C514.458 387.065 513.511 388.059 512.593 388.746H514.612V389.656H510.942V388.999Z"
            fill="#F6A200"
          />
          <path
            id="Vector_257"
            d="M515.402 389.137C515.402 388.792 515.669 388.532 516.005 388.532C516.35 388.532 516.617 388.792 516.617 389.137C516.617 389.465 516.35 389.733 516.005 389.733C515.661 389.733 515.402 389.465 515.402 389.137Z"
            fill="#F6A200"
          />
          <path
            id="Vector_258"
            d="M518.927 386.026L517.857 386.721L517.399 386.002L519.034 384.702H519.951V389.656H518.927V386.026Z"
            fill="#F6A200"
          />
          <path
            id="Vector_259"
            d="M521.139 389.152L521.575 388.448C521.896 388.739 522.347 388.846 522.752 388.846C523.395 388.846 523.83 388.525 523.83 388.021C523.83 387.631 523.471 387.31 522.852 387.31C522.6 387.31 522.393 387.348 522.149 387.486L521.804 386.881L523.303 385.612H521.392V384.702H524.617V385.582L523.441 386.613C523.578 386.621 523.708 386.653 523.838 386.691C524.449 386.866 524.893 387.356 524.893 388.059C524.893 389.183 523.96 389.733 522.844 389.733C522.125 389.733 521.53 389.511 521.139 389.152Z"
            fill="#F6A200"
          />
          <path
            id="Vector_260"
            d="M498.299 294.277C498.299 291.778 500.217 289.766 502.917 289.766C504.147 289.766 505.227 290.198 506.024 290.887L504.849 292.169C504.24 291.629 503.619 291.481 502.958 291.481C501.432 291.481 500.271 292.723 500.271 294.277C500.271 295.843 501.405 297.085 502.958 297.085C503.795 297.085 504.497 296.707 504.97 296.207V294.924H503.485V293.547H506.698V296.95C505.929 298.098 504.511 298.8 502.931 298.8C500.23 298.8 498.299 296.788 498.299 294.277Z"
            fill="#F6A200"
          />
          <path
            id="Vector_261"
            d="M508.208 291.9H509.991V293.195C510.18 292.642 510.868 291.765 512.354 291.765V293.737C510.787 293.737 510.018 294.451 510.018 296.059V298.652H508.208V291.9Z"
            fill="#F6A200"
          />
          <path
            id="Vector_262"
            d="M513.136 295.276C513.136 293.318 514.73 291.765 516.741 291.765C518.767 291.765 520.361 293.318 520.361 295.276C520.361 297.234 518.767 298.786 516.741 298.786C514.73 298.786 513.136 297.234 513.136 295.276ZM518.51 295.276C518.51 294.222 517.754 293.439 516.741 293.439C515.729 293.439 514.972 294.222 514.972 295.276C514.972 296.342 515.729 297.112 516.741 297.112C517.754 297.112 518.51 296.342 518.51 295.276Z"
            fill="#F6A200"
          />
          <path
            id="Vector_263"
            d="M521.182 297.868L521.829 296.478C522.289 296.828 522.924 297.194 523.937 297.194C524.355 297.194 525.044 297.031 525.044 296.626C525.044 296.221 524.463 296.126 523.882 295.964C522.545 295.613 521.451 295.167 521.451 293.871C521.451 292.493 522.802 291.765 524.072 291.765C525.179 291.765 525.881 292.034 526.583 292.44L525.976 293.79C525.314 293.466 524.693 293.318 524.099 293.318C523.68 293.318 523.288 293.506 523.288 293.79C523.288 294.168 523.856 294.29 524.477 294.425C525.624 294.695 526.88 295.195 526.88 296.571C526.88 298.233 525.193 298.786 523.937 298.786C522.491 298.786 521.56 298.22 521.182 297.868Z"
            fill="#F6A200"
          />
          <path
            id="Vector_264"
            d="M527.608 297.868L528.255 296.478C528.715 296.828 529.35 297.194 530.363 297.194C530.781 297.194 531.47 297.031 531.47 296.626C531.47 296.221 530.889 296.126 530.308 295.964C528.971 295.613 527.877 295.167 527.877 293.871C527.877 292.493 529.228 291.765 530.497 291.765C531.605 291.765 532.307 292.034 533.009 292.44L532.402 293.79C531.74 293.466 531.118 293.318 530.525 293.318C530.106 293.318 529.714 293.506 529.714 293.79C529.714 294.168 530.281 294.29 530.903 294.425C532.05 294.695 533.306 295.195 533.306 296.571C533.306 298.233 531.618 298.786 530.363 298.786C528.917 298.786 527.986 298.22 527.608 297.868Z"
            fill="#F6A200"
          />
          <path
            id="Vector_265"
            d="M534.182 295.276C534.182 293.331 535.695 291.765 537.679 291.765C539.516 291.765 540.961 293.331 540.961 295.248C540.961 295.572 540.92 295.897 540.92 295.897H536.018C536.235 296.828 537.004 297.275 537.896 297.275C538.543 297.275 539.219 297.085 539.718 296.747L540.394 298.044C539.637 298.543 538.76 298.786 537.882 298.786C535.91 298.786 534.182 297.504 534.182 295.276ZM539.259 294.695C539.124 293.844 538.449 293.277 537.625 293.277C536.842 293.277 536.167 293.844 535.991 294.695H539.259Z"
            fill="#F6A200"
          />
          <path
            id="Vector_266"
            d="M542.147 291.9H543.93V293.195C544.118 292.642 544.807 291.765 546.292 291.765V293.737C544.726 293.737 543.956 294.451 543.956 296.059V298.652H542.147V291.9Z"
            fill="#F6A200"
          />
          <path
            id="Vector_267"
            d="M498.272 309.316L498.961 307.858C499.663 308.37 500.5 308.817 501.837 308.817C502.567 308.817 503.457 308.479 503.457 307.79C503.457 307.114 502.674 306.939 501.905 306.75C500.271 306.372 498.582 305.819 498.582 303.995C498.582 302.307 500.162 301.47 501.837 301.47C503.16 301.47 504.159 301.821 505.037 302.402L504.349 303.861C503.647 303.402 502.729 303.158 501.837 303.158C501.378 303.158 500.514 303.333 500.514 303.995C500.514 304.563 501.149 304.765 502.013 304.968C503.566 305.332 505.429 305.913 505.429 307.79C505.429 309.681 503.593 310.504 501.837 310.504C499.744 310.504 498.758 309.707 498.272 309.316Z"
            fill="#F6A200"
          />
          <path
            id="Vector_268"
            d="M506.507 306.98C506.507 305.035 507.696 303.469 509.559 303.469C510.342 303.469 511.179 303.779 511.665 304.427V303.604H513.435V310.356H511.665V309.545C511.193 310.194 510.342 310.49 509.559 310.49C507.696 310.49 506.507 308.924 506.507 306.98ZM511.625 306.98C511.625 305.926 510.949 305.143 510.018 305.143C509.045 305.143 508.343 305.926 508.343 306.98C508.343 308.046 509.045 308.817 510.018 308.817C510.949 308.817 511.625 308.06 511.625 306.98Z"
            fill="#F6A200"
          />
          <path
            id="Vector_269"
            d="M514.607 306.98C514.607 305.035 515.795 303.469 517.658 303.469C518.442 303.469 519.279 303.779 519.765 304.427V303.604H521.534V310.356H519.765V309.545C519.292 310.194 518.442 310.49 517.658 310.49C515.795 310.49 514.607 308.924 514.607 306.98ZM519.725 306.98C519.725 305.926 519.049 305.143 518.117 305.143C517.145 305.143 516.443 305.926 516.443 306.98C516.443 308.046 517.145 308.817 518.117 308.817C519.049 308.817 519.725 308.06 519.725 306.98Z"
            fill="#F6A200"
          />
          <path id="Vector_270" d="M522.909 301.47H524.719V310.356H522.909V301.47Z" fill="#F6A200" />
          <path
            id="Vector_271"
            d="M479.696 307.808C486.78 302.082 490.014 298.75 490.014 296.033C490.014 294.513 489.012 293.219 486.942 293.219C485.615 293.219 483.933 293.865 482.218 295.418L480.019 292.571C482.574 289.79 485.712 289.305 487.297 289.305C491.276 289.305 494.575 291.504 494.575 295.645C494.575 299.624 490.565 303.829 486.682 306.74H495.223V310.59H479.696V307.808Z"
            fill="#F6A200"
          />
          <path
            id="Vector_272"
            d="M387.976 72.8336L387.053 78.9502L397.969 80.5976L398.892 74.4811L387.976 72.8336Z"
            fill="white"
          />
          <path
            id="Vector_273"
            d="M400.452 252.133C402.127 250.779 402.892 249.992 402.892 249.35C402.892 248.991 402.655 248.685 402.165 248.685C401.852 248.685 401.454 248.838 401.049 249.205L400.53 248.532C401.133 247.875 401.874 247.76 402.249 247.76C403.19 247.76 403.969 248.28 403.969 249.258C403.969 250.199 403.022 251.193 402.104 251.881H404.122V252.79H400.452V252.133Z"
            fill="#F6A200"
          />
          <path
            id="Vector_274"
            d="M404.912 252.27C404.912 251.926 405.18 251.667 405.516 251.667C405.861 251.667 406.128 251.926 406.128 252.27C406.128 252.599 405.861 252.867 405.516 252.867C405.172 252.867 404.912 252.599 404.912 252.27Z"
            fill="#F6A200"
          />
          <path
            id="Vector_275"
            d="M406.794 250.313C406.794 248.815 407.605 247.76 408.775 247.76C409.936 247.76 410.746 248.815 410.746 250.313C410.746 251.812 409.936 252.867 408.775 252.867C407.605 252.867 406.794 251.812 406.794 250.313ZM409.676 250.313C409.676 249.35 409.37 248.677 408.775 248.677C408.17 248.677 407.857 249.35 407.857 250.313C407.857 251.277 408.17 251.949 408.775 251.949C409.37 251.949 409.676 251.277 409.676 250.313Z"
            fill="#F6A200"
          />
          <path
            id="Vector_276"
            d="M412.997 249.159L411.927 249.855L411.469 249.136L413.105 247.837H414.022V252.79H412.997V249.159Z"
            fill="#F6A200"
          />
          <path
            id="Vector_277"
            d="M360.458 252.133C362.133 250.779 362.898 249.992 362.898 249.35C362.898 248.991 362.66 248.685 362.171 248.685C361.858 248.685 361.46 248.838 361.055 249.205L360.535 248.532C361.139 247.875 361.88 247.76 362.255 247.76C363.196 247.76 363.975 248.28 363.975 249.258C363.975 250.199 363.028 251.193 362.11 251.881H364.128V252.79H360.458V252.133Z"
            fill="#F6A200"
          />
          <path
            id="Vector_278"
            d="M364.918 252.27C364.918 251.926 365.186 251.667 365.522 251.667C365.866 251.667 366.134 251.926 366.134 252.27C366.134 252.599 365.866 252.867 365.522 252.867C365.178 252.867 364.918 252.599 364.918 252.27Z"
            fill="#F6A200"
          />
          <path
            id="Vector_279"
            d="M366.8 250.313C366.8 248.815 367.611 247.76 368.781 247.76C369.942 247.76 370.752 248.815 370.752 250.313C370.752 251.812 369.942 252.867 368.781 252.867C367.611 252.867 366.8 251.812 366.8 250.313ZM369.682 250.313C369.682 249.35 369.376 248.677 368.781 248.677C368.176 248.677 367.863 249.35 367.863 250.313C367.863 251.277 368.176 251.949 368.781 251.949C369.376 251.949 369.682 251.277 369.682 250.313Z"
            fill="#F6A200"
          />
          <path
            id="Vector_280"
            d="M371.39 252.133C373.065 250.779 373.829 249.992 373.829 249.35C373.829 248.991 373.592 248.685 373.103 248.685C372.789 248.685 372.392 248.838 371.987 249.205L371.467 248.532C372.071 247.875 372.812 247.76 373.187 247.76C374.127 247.76 374.906 248.28 374.906 249.258C374.906 250.199 373.959 251.193 373.041 251.881H375.06V252.79H371.39V252.133Z"
            fill="#F6A200"
          />
          <path
            id="Vector_281"
            d="M317.908 432.42C319.583 431.067 320.348 430.279 320.348 429.637C320.348 429.278 320.111 428.972 319.621 428.972C319.308 428.972 318.91 429.125 318.505 429.492L317.986 428.82C318.589 428.162 319.33 428.047 319.705 428.047C320.646 428.047 321.425 428.567 321.425 429.545C321.425 430.486 320.478 431.48 319.56 432.167H321.578V433.077H317.908V432.42Z"
            fill="#F6A200"
          />
          <path
            id="Vector_282"
            d="M322.368 432.558C322.368 432.213 322.636 431.953 322.972 431.953C323.317 431.953 323.584 432.213 323.584 432.558C323.584 432.886 323.317 433.154 322.972 433.154C322.628 433.154 322.368 432.886 322.368 432.558Z"
            fill="#F6A200"
          />
          <path
            id="Vector_283"
            d="M324.25 430.601C324.25 429.102 325.061 428.047 326.231 428.047C327.392 428.047 328.202 429.102 328.202 430.601C328.202 432.099 327.392 433.154 326.231 433.154C325.061 433.154 324.25 432.099 324.25 430.601ZM327.132 430.601C327.132 429.637 326.826 428.964 326.231 428.964C325.626 428.964 325.313 429.637 325.313 430.601C325.313 431.564 325.626 432.237 326.231 432.237C326.826 432.237 327.132 431.564 327.132 430.601Z"
            fill="#F6A200"
          />
          <path
            id="Vector_284"
            d="M331.364 429.033H328.756V428.123H332.548V428.766L330.453 433.077H329.337L331.364 429.033Z"
            fill="#F6A200"
          />
          <path
            id="Vector_285"
            d="M317.832 400.749C319.507 399.396 320.272 398.609 320.272 397.966C320.272 397.607 320.034 397.301 319.545 397.301C319.232 397.301 318.834 397.454 318.429 397.821L317.909 397.149C318.513 396.491 319.254 396.376 319.629 396.376C320.57 396.376 321.349 396.896 321.349 397.874C321.349 398.815 320.402 399.809 319.484 400.496H321.502V401.406H317.832V400.749Z"
            fill="#F6A200"
          />
          <path
            id="Vector_286"
            d="M322.292 400.887C322.292 400.542 322.56 400.282 322.896 400.282C323.24 400.282 323.508 400.542 323.508 400.887C323.508 401.215 323.24 401.483 322.896 401.483C322.552 401.483 322.292 401.215 322.292 400.887Z"
            fill="#F6A200"
          />
          <path
            id="Vector_287"
            d="M324.174 398.93C324.174 397.431 324.985 396.376 326.155 396.376C327.316 396.376 328.126 397.431 328.126 398.93C328.126 400.428 327.316 401.483 326.155 401.483C324.985 401.483 324.174 400.428 324.174 398.93ZM327.056 398.93C327.056 397.966 326.75 397.293 326.155 397.293C325.55 397.293 325.237 397.966 325.237 398.93C325.237 399.893 325.55 400.566 326.155 400.566C326.75 400.566 327.056 399.893 327.056 398.93Z"
            fill="#F6A200"
          />
          <path
            id="Vector_288"
            d="M328.764 399.725C328.764 399.25 328.94 398.769 329.239 398.371L330.744 396.346L331.555 396.896L330.691 398.035C330.737 398.028 330.798 398.02 330.836 398.02C331.807 398.02 332.518 398.761 332.518 399.671C332.518 400.695 331.807 401.483 330.637 401.483C329.468 401.483 328.764 400.726 328.764 399.725ZM331.448 399.717C331.448 399.258 331.126 398.884 330.637 398.884C330.141 398.884 329.834 399.258 329.834 399.717C329.834 400.206 330.125 400.581 330.637 400.581C331.142 400.581 331.448 400.206 331.448 399.717Z"
            fill="#F6A200"
          />
          <path
            id="Vector_289"
            d="M317.824 302.486C319.499 301.132 320.264 300.345 320.264 299.702C320.264 299.343 320.027 299.037 319.537 299.037C319.224 299.037 318.826 299.191 318.421 299.558L317.902 298.885C318.505 298.228 319.246 298.112 319.621 298.112C320.562 298.112 321.341 298.632 321.341 299.611C321.341 300.551 320.394 301.545 319.476 302.233H321.494V303.143H317.824V302.486Z"
            fill="#F6A200"
          />
          <path
            id="Vector_290"
            d="M322.284 302.623C322.284 302.279 322.552 302.019 322.888 302.019C323.233 302.019 323.5 302.279 323.5 302.623C323.5 302.951 323.233 303.219 322.888 303.219C322.544 303.219 322.284 302.951 322.284 302.623Z"
            fill="#F6A200"
          />
          <path
            id="Vector_291"
            d="M324.166 300.666C324.166 299.167 324.977 298.112 326.147 298.112C327.308 298.112 328.118 299.167 328.118 300.666C328.118 302.164 327.308 303.219 326.147 303.219C324.977 303.219 324.166 302.164 324.166 300.666ZM327.048 300.666C327.048 299.702 326.742 299.029 326.147 299.029C325.542 299.029 325.229 299.702 325.229 300.666C325.229 301.629 325.542 302.302 326.147 302.302C326.742 302.302 327.048 301.629 327.048 300.666Z"
            fill="#F6A200"
          />
          <path
            id="Vector_292"
            d="M328.756 302.638L329.193 301.935C329.513 302.226 329.964 302.332 330.369 302.332C331.012 302.332 331.448 302.011 331.448 301.507C331.448 301.117 331.088 300.796 330.469 300.796C330.217 300.796 330.01 300.834 329.766 300.972L329.421 300.367L330.92 299.099H329.009V298.189H332.235V299.069L331.058 300.1C331.196 300.108 331.325 300.139 331.455 300.177C332.067 300.353 332.51 300.842 332.51 301.545C332.51 302.669 331.577 303.219 330.461 303.219C329.742 303.219 329.147 302.997 328.756 302.638Z"
            fill="#F6A200"
          />
          <g id="Clip path group_3">
            <g id="Group_4">
              <g id="Group_5" opacity="0.5">
                <g id="Clip path group_4">
                  <g id="Group_6">
                    <g id="Clip path group_5">
                      <mask
                        id="mask1_2_1031"
                        style={{ maskType: 'luminance' }}
                        maskUnits="userSpaceOnUse"
                        x={489}
                        y={154}
                        width={10}
                        height={45}
                      >
                        <g id="clippath-104">
                          <path id="Vector_293" d="M498.453 154.796H489.875V198.722H498.453V154.796Z" fill="white" />
                        </g>
                      </mask>
                      <g mask="url(#mask1_2_1031)">
                        <g id="Group_7">
                          <path
                            id="Vector_294"
                            d="M493.917 198.392C492.426 198.392 491.219 197.241 491.219 195.62C491.219 194.9 491.462 194.251 491.883 193.781L492.645 194.478C492.337 194.834 492.248 195.199 492.248 195.556C492.248 196.512 492.993 197.208 493.917 197.208C494.857 197.208 495.611 196.529 495.611 195.596C495.611 195.111 495.424 194.664 495.068 194.34L495.862 193.636C496.348 194.138 496.64 194.819 496.64 195.62C496.64 197.241 495.432 198.392 493.917 198.392Z"
                            fill="#1D1D1B"
                          />
                          <path
                            id="Vector_295"
                            d="M491.3 191.157V190.039L496.55 187.755V188.905L495.716 189.262V191.928L496.55 192.284V193.443L491.3 191.157ZM494.832 189.618L493.333 190.226C492.937 190.388 492.41 190.591 492.394 190.599C492.41 190.607 492.937 190.81 493.333 190.971L494.832 191.579V189.618Z"
                            fill="#1D1D1B"
                          />
                          <path
                            id="Vector_296"
                            d="M491.3 187.157V183.228H492.273V186.023H493.342V183.641H494.306V186.023H496.55V187.157H491.3Z"
                            fill="#1D1D1B"
                          />
                          <path
                            id="Vector_297"
                            d="M491.3 182.621V178.513H492.273V181.487H493.342V178.667H494.306V181.487H495.578V178.4H496.55V182.621H491.3Z"
                            fill="#1D1D1B"
                          />
                          <path
                            id="Vector_298"
                            d="M492.273 176.262V178.045H491.3V173.346H492.273V175.128H496.55V176.262H492.273Z"
                            fill="#1D1D1B"
                          />
                          <path
                            id="Vector_299"
                            d="M491.3 172.658V168.55H492.273V171.524H493.342V168.704H494.306V171.524H495.578V168.437H496.55V172.658H491.3Z"
                            fill="#1D1D1B"
                          />
                          <path
                            id="Vector_300"
                            d="M491.3 167.734V165.481C491.3 163.934 492.207 163.123 493.333 163.123C494.006 163.123 494.655 163.472 495.003 164.12L496.55 163.027V164.33L495.319 165.141C495.343 165.295 495.36 165.433 495.36 165.586V166.599H496.55V167.734H491.3ZM494.387 165.448C494.387 164.784 493.908 164.322 493.333 164.322C492.734 164.322 492.264 164.784 492.264 165.441V166.599H494.387V165.448Z"
                            fill="#1D1D1B"
                          />
                          <path id="Vector_301" d="M491.3 162.307V161.172H496.55V162.307H491.3Z" fill="#1D1D1B" />
                          <path
                            id="Vector_302"
                            d="M491.3 158.28V157.162L496.55 154.878V156.029L495.716 156.385V159.051L496.55 159.407V160.566L491.3 158.28ZM494.832 156.741L493.333 157.349C492.937 157.511 492.41 157.714 492.394 157.722C492.41 157.73 492.937 157.933 493.333 158.094L494.832 158.702V156.741Z"
                            fill="#1D1D1B"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
            id="Vector_303"
            d="M451.353 236.719H477.932"
            stroke="#D0D4D7"
            strokeWidth="7.242"
            strokeMiterlimit={10}
          />
          <path id="Vector_304" d="M205.763 197.385H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_305" d="M205.763 234.939H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_306" d="M205.763 257.504H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_307" d="M205.763 281.388H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_308" d="M205.763 304.821H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_309" d="M205.763 328.407H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_310" d="M205.763 375.524H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_311" d="M205.763 351.739H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_312" d="M205.763 412.516H192.892" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_313" d="M505.545 238.761V253.334" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_314" d="M538.058 238.761V253.334" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_315" d="M603.672 348.256H590.801" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_316" d="M603.672 409.391H590.801" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_317" d="M281.862 306.078H268.991" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_318" d="M281.862 366.695H268.991" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_319" d="M281.862 342.913H268.991" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_320" d="M312.686 221.537V234.408" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_321" d="M215.147 154.077V166.948" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_322" d="M289.268 154.077V166.948" stroke="#D0D4D7" strokeWidth="3.6" strokeMiterlimit={10} />
          <path id="Vector_323" d="M136.272 455.293H129.129V462.436H136.272V455.293Z" fill="#D0D4D7" />
          <path id="Vector_324" d="M93.23 455.293H86.087V462.436H93.23V455.293Z" fill="#D0D4D7" />
          <path id="Vector_325" d="M50.186 455.293H43.043V462.436H50.186V455.293Z" fill="#D0D4D7" />
          <path id="Vector_326" d="M7.143 455.293H0V462.436H7.143V455.293Z" fill="#D0D4D7" />
          <path id="Vector_327" d="M136.272 113.693H129.129V120.836H136.272V113.693Z" fill="#D0D4D7" />
          <path id="Vector_328" d="M93.23 113.693H86.087V120.836H93.23V113.693Z" fill="#D0D4D7" />
          <path id="Vector_329" d="M50.186 113.693H43.043V120.836H50.186V113.693Z" fill="#D0D4D7" />
          <path id="Vector_330" d="M7.143 113.693H0V120.836H7.143V113.693Z" fill="#D0D4D7" />
          <path id="Vector_331" d="M7.143 156.395H0V163.538H7.143V156.395Z" fill="#D0D4D7" />
          <path id="Vector_332" d="M7.143 199.094H0V206.237H7.143V199.094Z" fill="#D0D4D7" />
          <path id="Vector_333" d="M7.143 241.793H0V248.936H7.143V241.793Z" fill="#D0D4D7" />
          <path id="Vector_334" d="M7.143 284.494H0V291.637H7.143V284.494Z" fill="#D0D4D7" />
          <path id="Vector_335" d="M7.143 327.193H0V334.336H7.143V327.193Z" fill="#D0D4D7" />
          <path id="Vector_336" d="M7.143 369.893H0V377.036H7.143V369.893Z" fill="#D0D4D7" />
          <path id="Vector_337" d="M7.143 412.594H0V419.737H7.143V412.594Z" fill="#D0D4D7" />
          <path
            id="BOOTH_2.15_2"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
            data-active={'2.15' in exhibitorLocations}
            data-booth="2.15"
            opacity="0.4"
            d="M651.681 435.666C656.452 443.93 655.662 453.319 649.915 456.637C644.168 459.954 635.642 455.945 630.87 447.681C626.099 439.417 626.891 430.028 632.637 426.71C638.384 423.393 646.91 427.402 651.681 435.666Z"
            fill="#F9B119"
          />
          <g id="Clip path group_6">
            <g id="Group_8">
              <path
                id="Vector_338"
                d="M136.783 320.771H157.192V301.122H136.783V320.771ZM147.04 318.378C142.968 318.378 139.665 315.109 139.665 311.075C139.665 307.042 142.968 303.773 147.04 303.773C151.113 303.773 154.415 307.042 154.415 311.075C154.415 315.109 151.113 318.378 147.04 318.378Z"
                fill="#1951A0"
              />
              <path
                id="Vector_339"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M148.23 314.785V308.874H144.583V310.656H145.738V314.802H144.575V316.568H149.401V314.785H148.23ZM146.986 308.038C147.813 308.038 148.384 307.504 148.384 306.729C148.385 305.893 147.854 305.325 147.064 305.325C146.245 305.323 145.648 305.877 145.647 306.642C145.644 307.454 146.203 308.036 146.986 308.038Z"
                fill="#1D1D1B"
              />
              <path id="Vector_340" d="M126.456 282.962L134.11 288.065L126.456 293.167V282.962Z" fill="#D51317" />
              <path
                id="Vector_341"
                d="M278.606 101.118H309.22V152.347H195.058"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path id="Vector_342" d="M265.796 85.2956L260.693 92.9496L255.591 85.2956H265.796Z" fill="#D51317" />
              <path id="Vector_343" d="M481.347 244.014L486.45 236.36L491.552 244.014H481.347Z" fill="#D51317" />
              <path id="Vector_344" d="M266.476 433.076L261.373 440.73L256.271 433.076H266.476Z" fill="#D51317" />
              <path
                id="Vector_345"
                d="M467.081 454.128V466.999"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_346"
                d="M401.23 454.128V466.999"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_347"
                d="M511.087 454.128V466.999"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_348"
                d="M543.575 454.128V466.999"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_349"
                d="M368.702 454.128V466.999"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_350"
                d="M324.526 268.329H311.656"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_351"
                d="M324.526 333.384H311.656"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_352"
                d="M324.526 377.369H311.656"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_353"
                d="M324.526 418.132H311.656"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_354"
                d="M391.38 236.882V249.753"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_355"
                d="M344.227 236.882V249.753"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_356"
                d="M423.908 233.973V249.753"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_357"
                d="M324.526 443.712H311.656"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_358"
                d="M427.118 295.205V361.486"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_359"
                d="M368.383 360.26H562.889"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_360"
                d="M433.553 295.205H420.682"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_361"
                d="M478.474 379.75H399.496"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_362"
                d="M368.383 353.825V366.696"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_363"
                d="M401.23 358.925V366.696"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_364"
                d="M401.23 373.641V381.412"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_365"
                d="M478.474 373.641V381.412"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_366"
                d="M439.852 373.641V381.412"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_367"
                d="M562.889 353.825V366.696"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_368"
                d="M478.474 352.818V360.529"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_369"
                d="M504.166 352.818V360.529"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_370"
                d="M452.865 352.818V360.529"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_371"
                d="M425.843 334.479H433.554"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_372"
                d="M425.843 301.741H433.554"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path id="Vector_373" d="M196.23 251.112H189.114V275.214H196.23V251.112Z" fill="white" />
              <path
                id="Vector_374"
                d="M712.087 238.163V466.37L196.216 466.573V275.214H189.161V473.627L719.142 473.553L719.189 238.163H712.087Z"
                fill="#D0D4D7"
              />
              <path id="Vector_375" d="M189.161 0.405823V278.915H196.216V1.87579L189.161 0.405823Z" fill="#D0D4D7" />
              <path
                id="Vector_376"
                d="M556.885 260.264V268.161H603.181V444.526H556.885V452.498"
                stroke="#D0D4D7"
                strokeWidth="7.055"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_377"
                d="M494.974 236.855H556.884V245.232"
                stroke="#D0D4D7"
                strokeWidth="7.055"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_378"
                d="M312.082 235.658L425.701 235.656"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_379"
                d="M280.556 343.407V235.658H312.081"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_380"
                d="M280.556 470.099V342.816"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_381"
                d="M192.892 4.7688L513.034 75.1958"
                stroke="#D0D4D7"
                strokeWidth="7.055"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_382"
                d="M281.754 375.303H242.733V432.18"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_383"
                d="M310.266 380.153H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_384"
                d="M310.266 383.19H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_385"
                d="M310.266 386.225H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_386"
                d="M310.266 389.26H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_387"
                d="M310.266 392.297H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_388"
                d="M310.266 395.334H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_389"
                d="M310.266 398.37H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_390"
                d="M310.266 401.407H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_391"
                d="M310.266 404.443H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_392"
                d="M310.266 407.479H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_393"
                d="M310.266 410.514H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_394"
                d="M310.266 413.551H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_395"
                d="M310.266 416.587H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_396"
                d="M310.266 419.624H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_397"
                d="M310.266 422.66H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_398"
                d="M310.266 425.696H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_399"
                d="M310.266 428.731H242.734"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_400"
                d="M279.401 99.1012H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_401"
                d="M279.401 102.138H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_402"
                d="M279.401 105.173H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_403"
                d="M279.401 108.209H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_404"
                d="M279.401 111.246H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_405"
                d="M279.401 114.282H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_406"
                d="M279.401 117.319H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_407"
                d="M279.401 120.355H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_408"
                d="M279.401 123.392H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_409"
                d="M279.401 126.426H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_410"
                d="M279.401 129.463H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_411"
                d="M279.401 132.499H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_412"
                d="M279.401 135.535H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_413"
                d="M279.401 138.572H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_414"
                d="M279.401 141.609H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_415"
                d="M279.401 144.643H241.153"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_416"
                d="M279.399 147.68H241.151"
                stroke="#D0D4D7"
                strokeWidth="0.882"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_417"
                d="M310.266 368.189V443.644H281.753"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_418"
                d="M310.266 370.38V268.306H281.753"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_419"
                d="M279.401 95.6138V151.819H242.731V95.6138"
                stroke="#D0D4D7"
                strokeWidth="3.527"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_420"
                d="M426.153 101.119H325.388V152.467H426.153V101.119Z"
                stroke="#D0D4D7"
                strokeWidth="3.527"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_421"
                d="M510.003 72.5776V236.856"
                stroke="#D0D4D7"
                strokeWidth="7.055"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_422"
                d="M363.745 152.349V202.704"
                stroke="#D0D4D7"
                strokeWidth="3.527"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_423"
                d="M337.161 152.349V167.159"
                stroke="#D0D4D7"
                strokeWidth="3.527"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_424"
                d="M363.745 167.159H335.397"
                stroke="#D0D4D7"
                strokeWidth="3.527"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_425"
                d="M556.885 241.705H718.94"
                stroke="#D0D4D7"
                strokeWidth="7.055"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_426"
                d="M280.222 235.69H270.301"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_427"
                d="M280.222 258.677H270.301"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_428"
                d="M280.222 282.264H270.301"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_429"
                d="M426.079 152.349V167.159"
                stroke="#D0D4D7"
                strokeWidth="3.527"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_430"
                d="M310.26 443.644V470.145"
                stroke="#D0D4D7"
                strokeWidth="3.6"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_431"
                d="M598.256 327.245V307.99"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_432"
                d="M596.18 327.245V307.99"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_433"
                d="M594.103 327.245V307.99"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_434"
                d="M592.025 327.245V307.99"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_435"
                d="M589.948 327.245V307.99"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_436"
                d="M587.87 327.245V307.99"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_437"
                d="M598.256 399.004V379.749"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_438"
                d="M596.18 399.004V379.749"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_439"
                d="M594.103 399.004V379.749"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_440"
                d="M592.025 399.004V379.749"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_441"
                d="M589.948 399.004V379.749"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_442"
                d="M587.87 399.004V379.749"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_443"
                d="M590.598 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_444"
                d="M588.521 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_445"
                d="M586.444 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_446"
                d="M584.366 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_447"
                d="M582.289 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_448"
                d="M580.212 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_449"
                d="M578.135 470.982V444.527"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_450"
                d="M590.598 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_451"
                d="M588.521 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_452"
                d="M586.444 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_453"
                d="M584.366 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_454"
                d="M582.289 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_455"
                d="M580.212 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_456"
                d="M578.135 268.16V241.705"
                stroke="#D0D4D7"
                strokeWidth="0.762"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_457"
                d="M310.999 274.417H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_458"
                d="M310.999 277.453H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_459"
                d="M310.999 280.488H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_460"
                d="M310.999 283.524H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_461"
                d="M310.999 286.561H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_462"
                d="M310.999 289.598H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_463"
                d="M310.999 292.634H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_464"
                d="M310.999 295.67H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_465"
                d="M310.999 298.707H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_466"
                d="M310.999 301.741H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_467"
                d="M310.999 304.778H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_468"
                d="M310.999 307.815H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_469"
                d="M310.999 310.851H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_470"
                d="M310.999 313.887H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_471"
                d="M310.999 316.924H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_472"
                d="M310.999 319.958H281.754"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_473"
                d="M310.266 431.77H281.111"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_474"
                d="M310.266 434.806H281.111"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_475"
                d="M310.266 437.843H281.111"
                stroke="#D0D4D7"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_476"
                d="M396.007 85.2312L389.405 78.8262L397.857 75.1952L396.007 85.2312Z"
                fill="#D51317"
              />
              <path
                id="Vector_477"
                d="M261.374 444.189V445.539"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_478"
                d="M261.374 447.889V451.414"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.35 2.35"
              />
              <path
                id="Vector_479"
                d="M261.374 452.589V453.939H260.024"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_480"
                d="M257.309 453.939H231.515"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.71 2.71"
              />
              <path
                id="Vector_481"
                d="M230.157 453.939H228.807V452.589"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_482"
                d="M228.807 449.871V201.198"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.72 2.72"
              />
              <path
                id="Vector_483"
                d="M228.807 199.84V198.49H230.157"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_484"
                d="M232.815 198.49H247.434"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.66 2.66"
              />
              <path
                id="Vector_485"
                d="M248.763 198.49H250.112"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
              />
              <path
                id="Vector_486"
                d="M308.239 198.49H323.718V219.075H434.936V278.916H352.226V427.945H570.386V389.414H581.093"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.7 2.7"
              />
              <path
                id="Vector_487"
                d="M611.894 389.419H670.658V317.619H611.894"
                stroke="#D51317"
                strokeWidth="0.444"
                strokeMiterlimit={10}
                strokeDasharray="2.66 2.66"
              />
              <path
                id="Vector_488"
                d="M486.506 239.214V285.713"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.8 2.8"
              />
              <path
                id="Vector_489"
                d="M581.092 318.337H486.107"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.7 2.7"
              />
              <path
                id="Vector_490"
                d="M486.45 233.025V215.563L465.787 215.56V137.449H486.45V95.0229L260.681 58.5909L260.632 84.2789"
                stroke="#D51317"
                strokeWidth="0.45"
                strokeMiterlimit={10}
                strokeDasharray="2.81 2.81"
              />
              <path
                id="Vector_491"
                d="M651.681 435.666C656.452 443.93 655.662 453.319 649.915 456.637C644.168 459.954 635.642 455.945 630.87 447.681C626.099 439.417 626.891 430.028 632.637 426.71C638.384 423.393 646.91 427.402 651.681 435.666Z"
                stroke="#F9B119"
                strokeWidth="0.9"
                strokeMiterlimit={10}
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
